import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Link,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Divider,
  Grid,
  TextField,
  Button,
  Snackbar,
  Alert, Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import PrintIcon from "@mui/icons-material/Print";
import BuildIcon from "@mui/icons-material/Build";
import BrushIcon from "@mui/icons-material/Brush";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import { db } from "./firebase";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom"; 
import paidIcon from "./paid.png";
import * as XLSX from "xlsx";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { getDisplayStatus, getDisplayName } from "./utils/statusLabels";
import { useBoxStaff, withBoxStaffNames } from "./utils/useBoxStaff";
import PrintChoiceBadge from "./components/PrintChoiceBadge";
const AdminDashboard = () => {
  // موظفات البوكسات (الحسابات الجديدة مثل تيهان) ينضافن لفلتر الموظفين تلقائياً
  const boxStaff = useBoxStaff();
  const [orders, setOrders] = useState([]);
    const navigate = useNavigate();
  // حساب ممنوح واجهة المدير من صلاحية المستخدمين (مثل محمد) يشوف الأرقام
  // والطلبات بس، بدون أزرار صفحات الإدارة
  const isAdminViewer = localStorage.getItem("username") === "admin";
  const [filteredOrders, setFilteredOrders] = useState([]);
  // 🔍 لستة العرض = filteredOrders + طلبات الماركتنك المطابقة للبحث (للعرض فقط، ما تدخل بالحسابات)
  const [displayOrders, setDisplayOrders] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedGovernorate, setSelectedGovernorate] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [paymentMethodFilter, setPaymentMethodFilter] = useState([]);
  const [paymentFilter, setPaymentFilter]= useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [activeStatFilter, setActiveStatFilter] = useState(null); // null | "all" | "done" | "inProgress"
const [selectedOrderType, setSelectedOrderType]  = useState([]);
const [saleAccountFilter, setSaleAccountFilter] = useState("الكل");
const [selectedProviderBox, setSelectedProviderBox] = useState(null);
const [pipelineStatusFilter, setPipelineStatusFilter] = useState(null);
const [prePipelineOrders, setPrePipelineOrders] = useState([]);
const [archivedOrders, setArchivedOrders] = useState([]);
const [invoiceCostRecords, setInvoiceCostRecords] = useState([]);
const [visibleOrdersCount, setVisibleOrdersCount] = useState(50);
const [backendFilterOptions, setBackendFilterOptions] = useState(null);
const [backendMonthlyBreakdownWithStatic, setBackendMonthlyBreakdownWithStatic] =
  useState(null);
  const [backendYearStats, setBackendYearStats] = useState(null);
  const [backendHeavyStats, setBackendHeavyStats] = useState(null);
  const [expandedOrderId, setExpandedOrderId] = useState(null);

  // ⏱️ نبضة كل دقيقة تحدّث دوائر تتبع الوقت (القسم الحالي اللي الطلب فيه هسة)
  const [stageClockNow, setStageClockNow] = useState(() => Date.now());
  useEffect(() => {
    const intervalId = setInterval(() => setStageClockNow(Date.now()), 60000);
    return () => clearInterval(intervalId);
  }, []);

  const compactStatBtnSx = {
  fontSize: "0.72rem",
  paddingX: 1,
  paddingY: 0.4,
  minWidth: "auto",
  whiteSpace: "nowrap",
};
const getTime = (t) => {
  if (!t) return 0;

  if (typeof t.toMillis === "function") return t.toMillis();

  if (t.seconds) return t.seconds * 1000;

  if (typeof t === "string" || typeof t === "number") {
    return new Date(t).getTime();
  }

  if (t instanceof Date) {
    return t.getTime();
  }

  return 0;
};

const getPackagingDate = (order) => {
  const history = Array.isArray(order.history) ? order.history : [];
  if (!history.length) return null;

  const sorted = [...history].sort(
    (a, b) => getTime(a.timestamp) - getTime(b.timestamp)
  );

  for (let i = 0; i < sorted.length; i++) {
    const st = sorted[i]?.status || "";

    if (
      st === "عند برهان - تغليف" ||
      st === "تغليف"
    ) {
      return toDateSafe(sorted[i]?.timestamp);
    }
  }

  return null;
};
const dashboardBoxStyle = {
  height: 65,
  borderRadius: 2,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  fontWeight: 500,
  fontSize: "13px",
  color: "#fff",
  cursor: "pointer",
  boxShadow: 1,
  transition: "all 0.2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: 3,
  },
};
// 🔴 أنواع مشاكل الفيدباك السلبي (تعريف ثابت)
const NEGATIVE_ISSUE_TYPES = [
  { key: "frame", label: "مشكلة في الإطار", icon: "🖼️" },
  { key: "printing", label: "مشكلة في الطباعة", icon: "🖨️" },
  { key: "drawing", label: "مشكلة في الرسم", icon: "🎨" },
  { key: "designer", label: "مشكلة في المصمم", icon: "📐" },
  { key: "transport", label: "مشكلة في شركة النقل", icon: "🚚" },
  { key: "employee", label: "مشكلة في الموظف المصمم", icon: "👤" },
];
const API_BASE =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000/api"
    : "https://artikaorder-backend.onrender.com/api";
const rejectedOrders =
  backendHeavyStats?.rejected?.rejectedOrders ||
  [...orders, ...archivedOrders].filter(
    (o) =>
      o.status?.startsWith("ملغي") ||
      o.rejectionType === "late_delivery" ||
      o.archiveReason === "late_delivery_rejected"
  );

const internalRejected =
  backendHeavyStats?.rejected?.internalRejected ||
  rejectedOrders.filter((o) => o.status === "ملغي - تأخير داخلي");

const lateRejected =
  backendHeavyStats?.rejected?.lateRejected ||
  rejectedOrders.filter(
    (o) =>
      o.status === "ملغي - وصل متأخر ورفضه الزبون" ||
      o.rejectionType === "late_delivery" ||
      o.archiveReason === "late_delivery_rejected"
  );

const damagedRejected =
  backendHeavyStats?.rejected?.damagedRejected ||
  rejectedOrders.filter((o) => o.status === "ملغي - متضررة");


// القيم: الكل | بيع | حساب نرسي | حساب استاذ مروان | ماركتنك
const [yearStatOwner, setYearStatOwner] = useState(null); 
const [delayDialogOpen, setDelayDialogOpen] = useState(false);
const buildNegativeIssuesDetails = (orders) => {
  const rows = [];

  orders.forEach((order) => {
    if (order.feedback?.type !== "سلبي") return;

    const note = order.feedback?.note || "";
    const employee = order.employee || "غير محدد";

    const issuesMap = [
      { label: "مشكلة في الإطار", source: "الإطار" },
      { label: "مشكلة في الطباعة", source: "الطباعة" },
      { label: "مشكلة في الرسم", source: "الرسم" },
      { label: "مشكلة في المصمم", source: "المصمم" },
      { label: "مشكلة في شركة النقل", source: "شركة النقل" },
      { label: "مشكلة في الموظف المصمم", source: "الموظف" },
    ];

    issuesMap.forEach((issue) => {
      if (note.includes(issue.label)) {
        rows.push({
          orderId: order.id,
          customerName: order.customerName,
          employee,
          issue: issue.label,
          source: issue.source,
            price: Number(order.price) || 0, // ✅ أضف السعر

        });
      }
    });
  });

  return rows;
};

// القيم: الكل | مدفوع | غير مدفوع
const [previewFile, setPreviewFile] = useState(null);
const [mockupDialogOrder, setMockupDialogOrder] = useState(null);
const [videoDialogOrder, setVideoDialogOrder] = useState(null);
const [framingVideoDialogOrder, setFramingVideoDialogOrder] = useState(null);
const [packagingVideoDialogOrder, setPackagingVideoDialogOrder] = useState(null);
const [yearFilter, setYearFilter] = useState(2026);
const [yearStatFilter, setYearStatFilter] = useState("all"); 
// all | done | inProgress

const [selectedSource, setSelectedSource]= useState([]);
// ✅ Facebook و Instagram موجودين كخيارات داخل نفس فلتر "مصدر الطلب" (نفس الحقل، نفس القائمة)
// بدل ما يكونون فلتر فرعي منفصل يظهر بعد اختيار "سوشال ميديا".
// orderMatchesSourceFilter تتكفل بمطابقتهم مع order.socialMediaSource تحت الغطاء.
// بالضغط على "سوشال ميديا" داخل نفس القائمة تطلع Facebook و Instagram كقائمة فرعية منسدلة تحتها.
const [socialMediaMenuOpen, setSocialMediaMenuOpen] = useState(false);
const paymentMethodLabel = {
  full_online: "دفع كامل أونلاين",
  full_cash: "دفعة كاملة كاش",
  deposit: "دفعة أولية",
  deposit_cash: "دفعة أولية كاش",
  cash_on_delivery: "دفع عند الاستلام",
};

const analyzeNegativeFeedback = (orders) => {
  const result = {};

  // تهيئة
  NEGATIVE_ISSUE_TYPES.forEach((t) => {
    result[t.key] = {
      label: t.label,
      icon: t.icon,
      count: 0,
      orders: [], // نخزن IDs
    };
  });

  orders.forEach((order) => {
    if (order.feedback?.type !== "سلبي") return;
    const note = order.feedback?.note || "";

    NEGATIVE_ISSUE_TYPES.forEach((t) => {
      if (note.includes(t.label)) {
        result[t.key].count += 1;
        result[t.key].orders.push(order.id);
      }
    });
  });

  return result;
};

// ✅ 1) تحويل Timestamp إلى Date safely
const toDateSafe = (ts) => {
  try {
    if (!ts) return null;

    if (typeof ts.toDate === "function") return ts.toDate();

    if (typeof ts.seconds === "number") {
      return new Date(ts.seconds * 1000);
    }

    if (typeof ts._seconds === "number") {
      return new Date(ts._seconds * 1000);
    }

    if (ts instanceof Date) {
      return ts;
    }

    if (typeof ts === "string" || typeof ts === "number") {
      const d = new Date(ts);
      return Number.isNaN(d.getTime()) ? null : d;
    }

    return null;
  } catch {
    return null;
  }
};
const formatDateTimeSafe = (value) => {
  const d = toDateSafe(value);

  if (!d) return "—";

  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(d.getDate()).padStart(2, "0")} ${String(
    d.getHours()
  ).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};
// ✅ 2) تحديد منو المسؤول عن الحالة
const resolveOwner = (order, status, by) => {
  if (!status) return by || null;

  // المصمم
  if (status === "عند يوسف") return "المصمم";

  // المطبعة (بوابة مطبعة الشركة - الطلب محبوس هناك بانتظار الطباعة)
  if (status === "عند المطبعة") return "المطبعة";

  // الورشة (كل حالات عند برهان حتى الرسم وغيرها)
  if (status.startsWith("عند برهان")) {
    // إذا رسم (حليمة أو محمد) - كلاهما الرسام
    if (status.includes("حليمة")) return "الرسام";
    if (status.includes("محمد")) return "الرسام";
    return "الورشة";
  }

  // إعادة للموظفة (أو رجوع)
  if (status.includes("اعادة") || status.includes("إعادة")) {
    return order.employee || by || null;
  }

  // fallback
  return by || null;
};

// ✅ 3) حساب مدة كل شخص داخل طلب واحد (بالدقائق)
const calcOrderDurationsByOwner = (order) => {
  const history = Array.isArray(order.history) ? [...order.history] : [];

  // إذا ماكو تاريخ كافي
  if (history.length < 2) return {};

  // ترتيب حسب الوقت
  history.sort((a, b) => {
    const da = toDateSafe(a.timestamp);
    const db = toDateSafe(b.timestamp);
    return (da?.getTime() || 0) - (db?.getTime() || 0);
  });

  const durations = {}; // { "المصمم": minutes, "الورشة": minutes, ... }

  for (let i = 0; i < history.length - 1; i++) {
    const cur = history[i];
    const next = history[i + 1];

    const curTime = toDateSafe(cur.timestamp);
    const nextTime = toDateSafe(next.timestamp);
    if (!curTime || !nextTime) continue;

    const diffMin = Math.max(0, Math.round((nextTime - curTime) / 60000));
    if (diffMin === 0) continue;
if (
  cur.status?.includes("رسم") &&
  !cur.status?.includes("محمد")
) {
  continue;
}
    const owner = resolveOwner(order, cur.status, cur.by);
    if (!owner) continue;

    durations[owner] = (durations[owner] || 0) + diffMin;
  }

  return durations;
};

// ✅ 4) تجميع على كل الطلبات (يعطيك: مجموع دقائق + عدد الطلبات اللي مرّت على الشخص + المتوسط)
const buildOwnersPerformance = (orders) => {
  const acc = {}; 
  // acc[owner] = { totalMinutes, ordersTouched: Set, eventsCount }

  for (const order of orders) {
    const d = calcOrderDurationsByOwner(order);

    Object.entries(d).forEach(([owner, minutes]) => {
      if (!acc[owner]) {
        acc[owner] = {
          totalMinutes: 0,
          ordersTouched: new Set(),
        };
      }
      acc[owner].totalMinutes += minutes;
      acc[owner].ordersTouched.add(order.id);
    });
  }

  // تحويل للعرض
  const result = Object.entries(acc).map(([owner, v]) => {
    const countOrders = v.ordersTouched.size;
    const avg = countOrders ? Math.round(v.totalMinutes / countOrders) : 0;
    return {
      owner,
      totalMinutes: v.totalMinutes,
      ordersCount: countOrders,
      avgMinutesPerOrder: avg,
    };
  });

  // ترتيب الأكثر تأخيراً
  result.sort((a, b) => b.avgMinutesPerOrder - a.avgMinutesPerOrder);

  return result;
};



const formatMinutesToDays = (minutes) => {
  const total = Number(minutes || 0);

  const days = Math.floor(total / (60 * 24));
  const hours = Math.floor((total % (60 * 24)) / 60);
  const mins = total % 60;

  let text = "";
  if (days > 0) text += `${days} يوم `;
  if (hours > 0) text += `${hours} ساعة `;
  if (mins > 0) text += `${mins} دقيقة`;

  return text.trim() || "0 دقيقة";
};

/* =============================
   3-ب) دوائر تتبع الوقت أعلى بطاقة الطلب (المصمم/المطبعة/الورشة/الرسم/التغليف)
   ملاحظة: هاي دالة منفصلة عن resolveOwner/calcOrderDurationsByOwner فوق —
   نفس المنطق بالضبط بس تفصل "التغليف" كقسم مستقل عن "الورشة"، حتى ما تتغيّر
   إحصائيات الأداء الحالية (أداء الموظفين / الطلبات المتأخرة) اللي تعتمد على
   الدالتين الأصليتين
   ============================= */
const resolveStageBadgeOwner = (order, status, by) => {
  if (!status) return by || null;

  if (status === "عند يوسف") return "المصمم";
  if (status === "عند المطبعة") return "المطبعة";

  if (status.startsWith("عند برهان")) {
    if (status.includes("حليمة")) return "الرسام";
    if (status.includes("محمد")) return "الرسام";
    if (status.includes("تغليف")) return "التغليف";
    return "الورشة";
  }

  if (status.includes("اعادة") || status.includes("إعادة")) {
    return order.employee || by || null;
  }

  return by || null;
};

// مدة كل قسم لطلب واحد (بالدقائق) + القسم الحالي اللي الطلب فيه هسة يترسم
// "مستمر" (ongoing: true) وتُحسب مدته حتى `now` بدل آخر transition بالتاريخ
const calcOrderStageBadgeDurations = (order, now) => {
  const history = Array.isArray(order.history) ? [...order.history] : [];
  const result = {}; // { owner: { minutes, ongoing } }
  if (!history.length) return result;

  history.sort((a, b) => {
    const da = toDateSafe(a.timestamp);
    const db = toDateSafe(b.timestamp);
    return (da?.getTime() || 0) - (db?.getTime() || 0);
  });

  const addMinutes = (owner, minutes, ongoing) => {
    if (!owner || minutes <= 0) return;
    if (!result[owner]) result[owner] = { minutes: 0, ongoing: false };
    result[owner].minutes += minutes;
    if (ongoing) result[owner].ongoing = true;
  };

  for (let i = 0; i < history.length; i++) {
    const cur = history[i];
    const next = history[i + 1];
    const curTime = toDateSafe(cur.timestamp);
    if (!curTime) continue;

    // نفس استثناء "رسم" (غير محمد) المستخدم بـ calcOrderDurationsByOwner فوق
    if (cur.status?.includes("رسم") && !cur.status?.includes("محمد")) continue;

    const owner = resolveStageBadgeOwner(order, cur.status, cur.by);
    if (!owner) continue;

    if (next) {
      const nextTime = toDateSafe(next.timestamp);
      if (!nextTime) continue;
      addMinutes(owner, Math.max(0, Math.round((nextTime - curTime) / 60000)), false);
    } else {
      addMinutes(owner, Math.max(0, Math.round((now - curTime) / 60000)), true);
    }
  }

  return result;
};

// صياغة عربية سليمة نحوياً حسب قواعد جمع الأعداد بالعربي (1: مفرد، 2: مثنى،
// 3-10: جمع، 11+: مفرد ملحق بالرقم)
const arabicCountWord = (n, forms) => {
  if (n === 1) return forms.one;
  if (n === 2) return forms.two;
  if (n >= 3 && n <= 10) return `${n} ${forms.few}`;
  return `${n} ${forms.many}`;
};
const DAY_WORDS = { one: "يوم", two: "يومين", few: "أيام", many: "يوم" };
const HOUR_WORDS = { one: "ساعة", two: "ساعتين", few: "ساعات", many: "ساعة" };
const MIN_WORDS = { one: "دقيقة", two: "دقيقتين", few: "دقائق", many: "دقيقة" };

// نص كامل (لصف الـ Tooltip) - مثال: "3 ساعات و 30 دقيقة" / "يوم و 5 ساعات"
const formatStageDurationFull = (minutesTotal) => {
  const total = Math.max(0, Math.round(Number(minutesTotal) || 0));
  const days = Math.floor(total / 1440);
  const hours = Math.floor((total % 1440) / 60);
  const mins = total % 60;

  if (days >= 1) {
    const parts = [arabicCountWord(days, DAY_WORDS)];
    if (hours > 0) parts.push(arabicCountWord(hours, HOUR_WORDS));
    return parts.join(" و ");
  }
  if (hours >= 1) {
    const parts = [arabicCountWord(hours, HOUR_WORDS)];
    if (mins > 0) parts.push(arabicCountWord(mins, MIN_WORDS));
    return parts.join(" و ");
  }
  return arabicCountWord(mins, MIN_WORDS);
};

// نص مختصر يترسم بداخل الدائرة نفسها - مثال: "23س 40د" / "يوم 5س"
const formatStageDurationShort = (minutesTotal) => {
  const total = Math.max(0, Math.round(Number(minutesTotal) || 0));
  const days = Math.floor(total / 1440);
  const hours = Math.floor((total % 1440) / 60);
  const mins = total % 60;

  if (days >= 1) {
    return `${days === 1 ? "يوم" : `${days}ي`}${hours > 0 ? ` ${hours}س` : ""}`;
  }
  if (hours >= 1) {
    return `${hours}س${mins > 0 ? ` ${mins}د` : ""}`;
  }
  return `${mins}د`;
};

const STAGE_BADGE_OVERDUE_MINUTES = 2 * 24 * 60; // يومين

const STAGE_BADGE_DEFS = [
  { owner: "المصمم", label: "المصمم", Icon: DesignServicesIcon, accent: "#8e44ad" },
  { owner: "المطبعة", label: "المطبعة", Icon: PrintIcon, accent: "#0057b8" },
  { owner: "الورشة", label: "الورشة", Icon: BuildIcon, accent: "#e67e22" },
  { owner: "الرسام", label: "الرسم", Icon: BrushIcon, accent: "#7b2ff7", onlyIfDrawing: true },
  { owner: "التغليف", label: "التغليف", Icon: Inventory2Icon, accent: "#d35400" },
];

// 🔵 دوائر تتبع الوقت بمستوى بطاقة الطلب (تبين مباشرة بدون فتح الطلب)
const OrderStageBadges = ({ order, now }) => {
  const durations = calcOrderStageBadgeDurations(order, now);
  const stages = STAGE_BADGE_DEFS.filter((s) => !s.onlyIfDrawing || order.withDrawing);

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: { xs: "6px", sm: "10px" }, flexShrink: 0 }}>
      {stages.map((stage) => {
        const entry = durations[stage.owner];
        const reached = !!entry;
        const overdue = reached && entry.minutes >= STAGE_BADGE_OVERDUE_MINUTES;
        const statusColor = !reached ? "#bdbdbd" : overdue ? "#c62828" : "#2e7d32";
        const iconColor = reached ? stage.accent : "#bdbdbd";
        const bg = !reached
          ? "#fafafa"
          : overdue
          ? "linear-gradient(180deg, #fff5f5 0%, #fdecea 100%)"
          : "linear-gradient(180deg, #f3fbf5 0%, #e8f5e9 100%)";

        return (
          <Tooltip
            key={stage.owner}
            arrow
            title={
              reached
                ? `${stage.label} — ${formatStageDurationFull(entry.minutes)}${
                    entry.ongoing ? " (مستمر الآن)" : ""
                  }`
                : `${stage.label} — لم يصل الطلب إلى هذا القسم بعد`
            }
          >
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: "50%",
                border: `2px solid ${statusColor}`,
                background: bg,
                boxShadow: reached
                  ? "0 2px 5px rgba(0,0,0,0.12)"
                  : "inset 0 0 0 1px rgba(0,0,0,0.03)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                cursor: "default",
                opacity: reached ? 1 : 0.55,
                transition: "transform 0.15s ease",
                "&:hover": { transform: reached ? "translateY(-2px)" : "none" },
                "@keyframes stageBadgePulse": {
                  "0%": { boxShadow: `0 0 0 0 ${statusColor}66` },
                  "70%": { boxShadow: `0 0 0 6px ${statusColor}00` },
                  "100%": { boxShadow: `0 0 0 0 ${statusColor}00` },
                },
                animation: entry?.ongoing ? "stageBadgePulse 2s infinite" : "none",
              }}
            >
              <stage.Icon sx={{ fontSize: 16, color: iconColor, lineHeight: 1 }} />
              {reached && (
                <span
                  style={{
                    fontSize: 8.5,
                    fontWeight: 700,
                    color: statusColor,
                    lineHeight: 1.3,
                    whiteSpace: "nowrap",
                    marginTop: 1,
                  }}
                >
                  {formatStageDurationShort(entry.minutes)}
                </span>
              )}
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};

const DONE_STATUSES = ["تم التوصيل", "تم التركيب", "تركيب", "تم التوصيل (بعد الفيدباك)"];

const getCompletionDate = (order) => {
  const history = Array.isArray(order.history) ? order.history : [];
  if (!history.length) return null;

  // نرتب تصاعدي
  const sorted = [...history].sort(
    (a, b) => getTime(a.timestamp) - getTime(b.timestamp)
  );

  // نبحث من الأخير للأول عن حالة مكتملة
  for (let i = sorted.length - 1; i >= 0; i--) {
    const st = sorted[i]?.status || "";
    if (DONE_STATUSES.includes(st)) {
      return toDateSafe(sorted[i]?.timestamp);
    }
  }

  // إذا الحالة الحالية مكتملة بس ما نلكاها بالتاريخ (احتياط)
  if (DONE_STATUSES.includes(order.status)) {
    // إذا عندك حقل جاهز مثل deliveredAt استخدمه هنا
    return toDateSafe(order.updatedAt) || null;
  }

  return null;
};

const getOrderTotalDurationMinutes = (order) => {
  const start = toDateSafe(order.createdAt);
  if (!start) return null;

  const end = getPackagingDate(order);

  if (!end) return null;

  const diff = Math.floor((end.getTime() - start.getTime()) / 60000);

  return diff > 0 ? diff : 0;
};
const formatDurationDaysOnly = (minutes) => {
  const total = Number(minutes || 0);
  const days = total / (60 * 24);

  if (days < 1) {
    return "أقل من يوم";
  }

  const rounded = Math.round(days * 10) / 10; // نص يوم مثل 1.5
  return `${rounded} يوم`;
};


const filteredDelayOrders = orders.filter(o => {
  const d = toDateSafe(o.createdAt);
  if (!d) return false;

  if (fromDate) {
    const from = new Date(fromDate);
    from.setHours(0,0,0,0);
    if (d < from) return false;
  }

  if (toDate) {
    const to = new Date(toDate);
    to.setHours(23,59,59,999);
    if (d > to) return false;
  }

  return true;
});
const performance = useMemo(() => {
  const hasDelayDateFilter = Boolean(fromDate || toDate);

  if (!hasDelayDateFilter && backendHeavyStats?.performance) {
    return backendHeavyStats.performance;
  }

  return buildOwnersPerformance(filteredDelayOrders).filter((p) =>
    ["المصمم", "الورشة", "الرسام"].includes(p.owner)
  );
}, [backendHeavyStats, filteredDelayOrders, fromDate, toDate]);



// ✅ الطلبات المكتملة فقط
const completedDurationAnalysis = useMemo(() => {
  const completedOrders = orders.filter((o) =>
    ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(
      o.status
    )
  );

  const completedDurations = completedOrders
    .map((o) => ({
      id: o.id,
      name: o.customerName,
      minutes: getOrderTotalDurationMinutes(o),
    }))
    .filter((o) => o.minutes !== null);

  const avgOrderDuration =
    completedDurations.length > 0
      ? Math.round(
          completedDurations.reduce((s, o) => s + o.minutes, 0) /
            completedDurations.length
        )
      : 0;

  const fastestOrders = [...completedDurations]
    .sort((a, b) => a.minutes - b.minutes)
    .slice(0, 3);

  const slowestOrders = [...completedDurations]
    .sort((a, b) => b.minutes - a.minutes)
    .slice(0, 3);

  return {
    completedOrders,
    completedDurations,
    avgOrderDuration,
    fastestOrders,
    slowestOrders,
  };
}, [orders]);

const {
  completedOrders,
  completedDurations,
  avgOrderDuration,
  fastestOrders,
  slowestOrders,
} = completedDurationAnalysis;

// 🔢 عدد أيام الشهر الحقيقي
const getDaysInMonth = (year, month) => {
  return new Date(year, month, 0).getDate(); // month: 1-12
};

// 📊 حساب معدل الطلبات باليوم
const getDailyAverage = (monthKey, count) => {
  if (!count) return 0;

  const [year, month] = monthKey.split("-").map(Number);
  const now = new Date();

  const isCurrentMonth =
    now.getFullYear() === year && now.getMonth() + 1 === month;

  // إذا الشهر الحالي نحسب لليوم الحالي، غيره نحسب كامل الشهر
  const days = isCurrentMonth
    ? now.getDate()
    : getDaysInMonth(year, month);

  return Math.round(count / days); // ✅ بدون فاصلة
};


const isPaymentVisible = (order) => {
  if (!order.deliveryPaid) return false;

  if (!order.deliveryPaidVisibleAt) return true;

  const visibleAt = toDateSafe(order.deliveryPaidVisibleAt);
  if (!visibleAt) return true;

  return visibleAt <= new Date();
};
// 📦 طلبات ثابتة للأشهر 5 / 6 / 7 (للإكسل فقط)
const staticExcelOrders = [
  // ===== 2025-01 =====
  {
    customerName: "طلبات أرشيفية",
    price: 695000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-01",
    note: "طلبات ثابتة",
  },

  // ===== 2025-02 =====
  {
    customerName: "طلبات أرشيفية",
    price: 2060000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-02",
    note: "طلبات ثابتة",
  },

  // ===== 2025-03 =====
  {
    customerName: "طلبات أرشيفية",
    price: 3275000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-03",
    note: "طلبات ثابتة",
  },

  // ===== 2025-04 =====
  {
    customerName: "طلبات أرشيفية",
    price: 2050000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-04",
    note: "طلبات ثابتة",
  },
  // ===== 2025-05 =====
  {
    customerName: "طلبات أرشيفية - Sales",
    price: 450000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-05",
    note: "طلبات ثابتة",
  },
  {
    customerName: "طلبات أرشيفية - Marketing",
    price: 2894000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Marketing",
    createdAt: "2025-05",
    note: "طلبات ثابتة",
  },

  // ===== 2025-06 =====
  {
    customerName: "طلبات أرشيفية - Sales",
    price: 4425000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-06",
    note: "طلبات ثابتة",
  },
  {
    customerName: "طلبات أرشيفية - Marketing",
    price: 7307000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Marketing",
    createdAt: "2025-06",
    note: "طلبات ثابتة",
  },

  // ===== 2025-07 =====
  {
    customerName: "طلبات أرشيفية - Sales",
    price: 5464000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Sales",
    createdAt: "2025-07",
    note: "طلبات ثابتة",
  },
  {
    customerName: "طلبات أرشيفية - Marketing",
    price: 3563000,
    governorate: "—",
    status: "تم التوصيل",
    employee: "—",
    source: "أرشيف",
    orderType: "Marketing",
    createdAt: "2025-07",
    note: "طلبات ثابتة",
  },
];
// ✅ حالات تعتبر "اكتمال" حسب نظامك

// ✅ يرجع تاريخ الاكتمال من history (آخر مرة وصل لمرحلة مكتملة)

// ✅ يحسب عدد الأيام بين تاريخين
const diffDays = (startDate, endDate) => {
  if (!startDate || !endDate) return "";
  const ms = endDate.getTime() - startDate.getTime();
  const days = Math.ceil(ms / (1000 * 60 * 60 * 24));
  return days > 0 ? days : 0;
};

// ✅ تنسيق تاريخ عربي
const formatDateAR = (d) => (d ? d.toLocaleString("ar-IQ") : "");

// ✅ تنسيق تاريخ انكليزي لاكسل الطلبات بناءً على طلب صريح - صيغة
// السنة/اليوم/اسم الشهر المختصر بالانكليزي بأحرف صغيرة (مثال: 2026/26/sep)
const MONTH_ABBR_EN = [
  "jan", "feb", "mar", "apr", "may", "jun",
  "jul", "aug", "sep", "oct", "nov", "dec",
];
const formatDateEN = (d) => {
  if (!d) return "";
  const day = String(d.getDate()).padStart(2, "0");
  const month = MONTH_ABBR_EN[d.getMonth()];
  const year = d.getFullYear();
  return `${year}/${day}/${month}`;
};
const normalizeText = (value) => {
  return String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();
};

const getInvoiceCostsForOrder = (order) => {
  const orderInvoiceId = order.invoiceId || order.sourceInvoiceId || "";
  const orderInvoiceNumber = order.invoiceNumber || "";
  const orderCustomerName = normalizeText(order.customerName);

  const matchedCosts = invoiceCostRecords.filter((r) => {
    // أفضل ربط إذا موجود invoiceId
    if (orderInvoiceId && r.invoiceId && r.invoiceId === orderInvoiceId) {
      return true;
    }

    // ثاني أفضل ربط إذا موجود invoiceNumber
    if (
      orderInvoiceNumber &&
      (r.invoiceNumber || r.receiptNumber) &&
      String(r.invoiceNumber || r.receiptNumber) === String(orderInvoiceNumber)
    ) {
      return true;
    }
// احتياط: الربط باسم الزبون
    return (
      orderCustomerName &&
      normalizeText(r.customerName || r.processName) === orderCustomerName
    );
  });

  const printCost = matchedCosts
    .filter((r) => r.invoiceCostAccountName === "مطبعة صدى سومر 2")
    .reduce((sum, r) => sum + Number(r.amountIQD || 0), 0);

  const frameCost = matchedCosts
    .filter((r) => r.invoiceCostAccountName === "إطارات توب فريم 2")
    .reduce((sum, r) => sum + Number(r.amountIQD || 0), 0);

  return {
    printCost,
    frameCost,
    totalCost: printCost + frameCost,
  };
};
const exportToExcel = () => {
  let exportOrders = [...orders];

  // فلترة بالتاريخ (للطلبات الحقيقية فقط)
  if (fromDate && toDate) {
    const from = new Date(fromDate);
    const to = new Date(toDate);
    to.setHours(23, 59, 59, 999);

    exportOrders = exportOrders.filter((order) => {
      const createdAt = toDateSafe(order.createdAt);
      return createdAt && createdAt >= from && createdAt <= to;
    });
  }

  // 🔥 دمج الطلبات الحقيقية + الطلبات الثابتة
  const mergedOrders = [...exportOrders, ...staticExcelOrders];

  if (mergedOrders.length === 0) {
    alert("لا توجد طلبات للتصدير");
    
    return;
  }

const data = mergedOrders.map((order, index) => {
  // ✅ تاريخ الإنشاء
 const created =
  typeof order.createdAt === "string" && order.createdAt.length === 7
    ? null
    : toDateSafe(order.createdAt);

  // ✅ تاريخ الاكتمال - بالانكليزي (سنة/يوم/اسم الشهر مختصر) بناءً على طلب صريح
  const completionDate =
    typeof order.createdAt === "string"
      ? "" // الطلبات الأرشيفية ما بيها تواريخ تفصيلية
      : formatDateEN(getCompletionDate(order));

  // ✅ فترة الطلب بالأيام
  const durationDays =
    typeof order.createdAt === "string"
      ? "" // الأرشيف لا نحسبه
      : diffDays(created, getCompletionDate(order));

  // ✅ الأعمدة المطلوبة
  const totalBoards = Number(order.boardsCount || 0);
  const hasDrawing = order.withDrawing === true ? "نعم" : "لا";
  const drawingBoards = Number(order.drawingBoardsCount || 0);
  const hasAssembly = order.withAssembly === true ? "نعم" : "لا";
const invoiceCosts = getInvoiceCostsForOrder(order);
  return {
    "تسلسل": index + 1,
    "اسم الزبون": order.customerName || "",
    "رقم هاتف الزبون": order.customerPhone || "",
    "المبلغ": Number(order.price || 0),
    "مطبعة": invoiceCosts.printCost > 0 ? invoiceCosts.printCost : "",
"إطارات": invoiceCosts.frameCost > 0 ? invoiceCosts.frameCost : "",
"حساب تكلفة اللوحة": invoiceCosts.totalCost > 0 ? invoiceCosts.totalCost : "",
    "المحافظة": order.governorate || "",
    "الحالة":
      (order.completedSteps?.length
        ? getDisplayStatus(
            `عند برهان - ${order.completedSteps[order.completedSteps.length - 1]}`
          )
        : getDisplayStatus(order.status, order)) || "",
 "الموظف": order.employee || "",
"مصدر الطلب": order.source || "",
"مصدر السوشال ميديا": order.socialMediaSource || "",
"نوع الزبون": orderTypeLabels[order.orderType] || order.orderType || "",

    // ✅ بالانكليزي (سنة/يوم/اسم الشهر مختصر، مثال: 2026/26/sep) بناءً على طلب صريح
    "تاريخ الطلب":
      typeof order.createdAt === "string"
        ? order.createdAt
        : formatDateEN(created),

    // ✅ جديد مثل الصورة
    "تاريخ التوصيل - اكتمال الطلب": completionDate,
    "فترة الطلب بالأيام": durationDays,
    "عدد اللوحات الكلي": totalBoards,
    "رسم": hasDrawing,
    "عدد لوحات الرسم": drawingBoards,
    "تركيب": hasAssembly,

    "ملاحظات": order.note || "",
  };
});


  const worksheet = XLSX.utils.json_to_sheet(data);
worksheet["!cols"] = [
  { wch: 6 },   // تسلسل
  { wch: 18 },  // اسم الزبون
  { wch: 16 },  // رقم هاتف الزبون
  { wch: 12 },  // المبلغ
  { wch: 14 },  // مطبعة
  { wch: 14 },  // إطارات
  { wch: 18 },  // حساب تكلفة اللوحة
  { wch: 12 },  // المحافظة
  { wch: 18 },  // الحالة
  { wch: 10 },  // الموظف
  { wch: 14 },  // مصدر الطلب
  { wch: 20 },  // مصدر السوشال ميديا
  { wch: 16 },  // نوع الزبون
  { wch: 22 },  // تاريخ الطلب
  { wch: 28 },  // تاريخ التوصيل - اكتمال الطلب
  { wch: 16 },  // فترة الطلب بالأيام
  { wch: 14 },  // عدد اللوحات الكلي
  { wch: 8 },   // رسم
  { wch: 14 },  // عدد لوحات الرسم
  { wch: 10 },  // تركيب
  { wch: 20 },  // ملاحظات
];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "الطلبات");

  XLSX.writeFile(workbook, "طلبات_ارتيكا_كاملة.xlsx");
};

  useEffect(() => {
    fetchOrders();
  }, []);
  useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearchTerm(searchTerm);
  }, 300);

  return () => clearTimeout(timer);
}, [searchTerm]);
useEffect(() => {
  setVisibleOrdersCount(50);
  setExpandedOrderId(null);
}, [
  selectedEmployee,
  selectedStatus,
  selectedGovernorate,
  debouncedSearchTerm,
  fromDate,
  selectedSource,
  toDate,
  selectedMonth,
  activeStatFilter,
  selectedOrderType,
  paymentFilter,
  paymentMethodFilter,
  saleAccountFilter,
  yearFilter,
  yearStatFilter,
  yearStatOwner,
  pipelineStatusFilter,
]);
const fetchOrders = async () => {
  try {
    const res = await fetch(`${API_BASE}/admin-dashboard/base-data`);

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.details || data.error || "فشل تحميل بيانات المدير");
    }

    const sorted = Array.isArray(data.orders) ? data.orders : [];
    const archivedSorted = Array.isArray(data.archivedOrders)
      ? data.archivedOrders
      : [];
    const invoiceCosts = Array.isArray(data.invoiceCostRecords)
      ? data.invoiceCostRecords
      : [];

    setOrders(sorted);
    setFilteredOrders(sorted);
    setDisplayOrders(sorted);
    setArchivedOrders(archivedSorted);
    setInvoiceCostRecords(invoiceCosts);
    setBackendFilterOptions(data.filterOptions || null);
setBackendMonthlyBreakdownWithStatic(data.monthlyBreakdownWithStatic || null);
setBackendYearStats(data.yearStats || null);
setBackendHeavyStats(data.heavyStats || null);

  } catch (error) {
    console.error("❌ Admin dashboard load error:", error);
    alert("حدث خطأ أثناء تحميل بيانات لوحة المدير");
  }
};
const matchFilter = (value, filterArray) => {
  if (!filterArray || filterArray.length === 0) return true;
  if (filterArray.includes("الكل")) return true;
  return filterArray.includes(value);
};

// ✅ فلتر مصدر الطلب: Facebook و Instagram خيارات داخل نفس القائمة، بس فعلياً
// order.source بيكون "سوشال ميديا" وتفصيل المنصة محفوظ بـ order.socialMediaSource
const orderMatchesSourceFilter = (order, filterArray) => {
  if (!filterArray || filterArray.length === 0) return true;
  if (filterArray.includes("الكل")) return true;
  return filterArray.some((val) => {
    if (val === "Facebook" || val === "Instagram" || val === "WhatsApp") {
      return order.source === "سوشال ميديا" && order.socialMediaSource === val;
    }
    return order.source === val;
  });
};

// ✅ فلتر نوع الزبون (متعدد الاختيار) - يدعم القيم الجديدة وخريطة القيم العربية القديمة
const orderMatchesTypes = (order, selectedTypes) => {
  if (!selectedTypes || !selectedTypes.length || selectedTypes.includes("الكل")) {
    return true;
  }
  const orderType = order.orderType || "";
  const reverseMap = {
    "مشروع - فندق": "project_hotel",
    "مشروع - مطعم": "project_restaurant",
    "مشروع - كافيه": "project_cafe",
    "مشروع - صالون": "project_salon",
    "مشروع - عيادة": "project_clinic",
    "مهندس أو مصمم": "engineer_designer",
    "شركة هندسية أو شركة تصميم داخلي": "engineering_company",
    "شقة": "apartment",
    "بيت": "house",
    "انفلونسر / بلوكر / مشهور": "influencer",
    "شركة اثاث": "furniture_company",
  };
  return selectedTypes.some((sel) => {
    if (orderType === sel) return true;
    if (sel === "other_company") return orderType.startsWith("شركات أخرى");
    return reverseMap[orderType] === sel;
  });
};

// ✅ تطابق حالة الطلب مع أحد مفاتيح الحالة الثابتة (fixedStatuses) - يستخدمها فلتر
// الحالة (dropdown) وبوكسات مراحل العمل بالأعلى معاً
const matchStatusKey = (order, selected) => {
  const status = order.status || "";
  const lastStep =
    order.completedSteps?.[order.completedSteps.length - 1] || "";

  switch (selected) {
    case "عند المصمم":
      return status === "عند يوسف";

    case "عند الورشة":
      return status.startsWith("عند برهان");

    case "عند المطبعة":
      return status === "عند المطبعة";

    case "طباعة":
      return status.startsWith("عند برهان") && lastStep === "طباعة";

    case "اطار":
      return (
        status.startsWith("عند برهان") &&
        (lastStep === "إطار" || lastStep === "اطار")
      );

    case "تغليف":
      return status.startsWith("عند برهان") && lastStep === "تغليف";

    case "🚀 رسم - بدأ":
      return status.includes("رسم") && status.includes("بدأ");

    case "✅ رسم - مكتمل":
      return status.includes("رسم") && status.includes("مكتمل");

    // كل طلب وصل للرسام (بانتظاره، بدأ، أو مكتمل) - نفس شرط ليبل "عند الرسام"
    // بـutils/statusLabels.js
    case "عند الرسام":
      return status.includes("رسم");

    case "تم التوصيل":
      return ["تم التوصيل", "تم التوصيل (بعد الفيدباك)"].includes(status);

    case "تم التركيب":
      return ["تم التركيب", "تركيب"].includes(status);

    case "   📩 تم التوصيل_فيدباك":
      return status === "feedbackRequired";

    default:
      return false;
  }
};

// ✅ فلترة بوكسات الإحصائيات (الصف العام + صفوف السنين) - نفس شروط الحساب
// المستخدمة بالأرقام المعروضة على البوكسات حتى اللستة تطابق الرقم
const matchStatBoxFilter = (order, key) => {
  switch (key) {
    case "done":
      return DONE_STATUSES.includes(order.status);
    case "inProgress":
      return !DONE_STATUSES.includes(order.status);
    case "positive":
      return order.feedback?.type === "ايجابي";
    case "negative":
      return order.feedback?.type === "سلبي";
    case "boards":
      return Number(order.boardsCount || 0) > 0;
    case "drawingOrders":
      return order.withDrawing === true;
    case "drawingBoards":
      return Number(order.drawingBoardsCount || 0) > 0;
    case "install":
      return order.withAssembly === true;
    default:
      return true; // "all" أو null
  }
};
const matchYearStatFilter = matchStatBoxFilter;

// 🔍 البحث باسم الزبون أو رقم هاتفه
const matchSearch = (order, term) => {
  const normalizedSearch = term.trim().toLowerCase();
  if ((order.customerName || "").toLowerCase().includes(normalizedSearch)) return true;
  const searchDigits = normalizedSearch.replace(/\D/g, "");
  if (!searchDigits) return false;
  return String(order.customerPhone || "").replace(/\D/g, "").includes(searchDigits);
};

  useEffect(() => {
    let result = [...orders];
        result = result.filter(order => !order.excludedFromStats);

// ✅ افتراضيًا: استبعد طلبات الماركتنك من كل الفلاتر العامة
// إلا إذا المستخدم اختار "ماركتنك" صراحة
// 🔍 استثناء: أثناء البحث تظهر طلبات الماركتنك بلستة الطلبات (للعرض فقط)،
// لكن تنشال من filteredOrders اللي تنحسب منه الإحصائيات بالأسفل - فالحسابات ما تتغير
const includeMarketingForSearch =
  debouncedSearchTerm.trim() !== "" && saleAccountFilter !== "ماركتنك";
if (saleAccountFilter !== "ماركتنك" && !includeMarketingForSearch) {
  result = result.filter((order) => (order.saleAccount || "بيع") !== "ماركتنك");
}

 result = result.filter((order) =>
  matchFilter(order.employee, selectedEmployee)
);
// ✅ يستخدم matchStatusKey (نفس دالة بوكسات مراحل العمل) بدل نسخة مكررة كانت
// تستخدم مسافات مختلفة لمفتاح "📩 تم التوصيل_فيدباك" عن fixedStatuses/
// workflowStages، فيفشل التطابق دائماً ويرجّع لستة فارغة عند اختيار هذي
// الحالة من فلتر الحالات (dropdown) رغم أن بوكس المرحلة (pipelineStatusFilter)
// كان يعمل بشكل صحيح لأنه يستخدم matchStatusKey من الأصل
if (selectedStatus.length > 0) {
  result = result.filter((order) =>
    selectedStatus.some((selected) => matchStatusKey(order, selected))
  );
}



 result = result.filter((order) =>
  matchFilter(order.governorate, selectedGovernorate)
);
 result = result.filter((order) =>
  orderMatchesSourceFilter(order, selectedSource)
);
// ✅ فلترة حسب حساب البيع (بوكسات المدير)
if (saleAccountFilter !== "الكل") {
  result = result.filter((order) => (order.saleAccount || "بيع") === saleAccountFilter);
}
// ✅ فلترة حسب بوكسات السنة (2025/2026)
// ✅ فلترة حسب السنة (2025 / 2026)
// ✅ فلترة حسب السنة (2025 / 2026)
// ✅ فلترة السنة تعمل فقط إذا لا يوجد بحث باسم الزبون
if (yearFilter !== "الكل" && debouncedSearchTerm.trim() === "") {
  result = result.filter((order) => {
    const d = toDateSafe(order.createdAt);
    if (!d) return false;
    return d.getFullYear() === yearFilter;
  });
}
// ✅ فلترة بوكسات السنة (تشتغل فقط إذا المالك هو نفس السنة المختارة)
if (yearFilter !== "الكل" && yearStatOwner === yearFilter) {
  result = result.filter((order) => matchYearStatFilter(order, yearStatFilter));
}



if (debouncedSearchTerm.trim() !== "") {
  result = result.filter((order) => matchSearch(order, debouncedSearchTerm));
}
if (paymentFilter.length > 0 && !paymentFilter.includes("الكل")) {

result = result.filter(order => {

return paymentFilter.some(filter => {

if(filter === "مدفوع") return isPaymentVisible(order)

if(filter === "غير مدفوع") return !isPaymentVisible(order)

return false

})

})

}
// ✅ فلترة حسب طريقة الدفع
result = result.filter((order) =>
  matchFilter(order.payment?.method, paymentMethodFilter)
);

    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      result = result.filter((order) => {
        const createdAt = toDateSafe(order.createdAt);
        return createdAt >= from && createdAt <= to;
      });
    }
    // ✅ فلترة حسب السنة (2025 / 2026)
// ✅ فلترة حسب السنة (2025 / 2026)
// ✅ فلترة السنة تعمل فقط إذا لا يوجد بحث باسم الزبون

    if (selectedMonth) {
      result = result.filter((order) => {
        const date = toDateSafe(order.createdAt);
        if (!date) return false;
        const key = `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, "0")}`;
        return key === selectedMonth;
      });
    }

    // فلترة حسب الزر المضغوط (الإحصائيات)
if (activeStatFilter) {
  result = result.filter((order) => matchStatBoxFilter(order, activeStatFilter));
}

if (selectedOrderType.length > 0 && !selectedOrderType.includes("الكل")) {
  result = result.filter((order) => orderMatchesTypes(order, selectedOrderType));
}

// 🔍 نسخة الإحصائيات بدون ماركتنك (نفس السابق بالضبط) - طلبات الماركتنك اللي
// دخلت بسبب البحث تبقى بس بلستة العرض displayOrders
const withoutSearchMarketing = (list) =>
  includeMarketingForSearch
    ? list.filter((order) => (order.saleAccount || "بيع") !== "ماركتنك")
    : list;

// ✅ بوكسات مراحل العمل (فوق لستة الطلبات) - نحفظ النتيجة قبل تطبيق هذا الفلتر
// حتى نقدر نحسب عدد كل حالة بشكل مستقل عن الحالة المختارة حالياً
setPrePipelineOrders(withoutSearchMarketing(result));

if (pipelineStatusFilter) {
  result = result.filter((order) => matchStatusKey(order, pipelineStatusFilter));
}

    setFilteredOrders(withoutSearchMarketing(result));
    setDisplayOrders(result);
  }, [
    selectedEmployee,
    selectedStatus,
    selectedGovernorate,
    debouncedSearchTerm,
    fromDate,
      selectedSource,
    toDate,
    selectedMonth,
    activeStatFilter,
    selectedOrderType,
    orders,
      paymentFilter, // ✅ هذا هو الحل
      paymentMethodFilter,
   saleAccountFilter,
     yearFilter, // ✅ مهم جداً
yearStatFilter,
yearStatOwner,
pipelineStatusFilter,

  ]);

  const employeeRoster = withBoxStaffNames(["رند", "جمانا", "ساره", "بنين", "مياسة", "فرح"], boxStaff);
  // ✅ إذا تم اختيار نوع زبون محدد، تظهر فقط الموظفين اللي عندهم طلبات من هذا النوع
  const uniqueEmployees =
    !selectedOrderType.length || selectedOrderType.includes("الكل")
      ? ["الكل", ...employeeRoster]
      : [
          "الكل",
          ...employeeRoster.filter((name) =>
            orders.some(
              (o) => o.employee === name && orderMatchesTypes(o, selectedOrderType)
            )
          ),
        ];
const fixedStatuses = [
  "الكل",
  "عند المصمم",
  "عند المطبعة",
  "عند الورشة",
  "طباعة",
  "اطار",
  "🚀 رسم - بدأ",
  "✅ رسم - مكتمل",
  "تغليف",
  "تم التوصيل",
  "تم التركيب",
  "   📩 تم التوصيل_فيدباك",
];

// ✅ مراحل العمل بالتسلسل (بوكسات فوق لستة الطلبات) - نفس ترتيب fixedStatuses بدون "الكل"
const workflowStages = [
  { key: "عند المصمم", icon: "🎨", color: "#8e44ad" },
  { key: "عند المطبعة", icon: "🖨️", color: "#0057b8" },
  { key: "عند الورشة", icon: "🏭", color: "#e67e22" },
  // hidden = بوكس مخفي (بطلب الإدارة) - المرحلة نفسها وفلترها باقيين
  { key: "طباعة", icon: "🖼️", color: "#16a085", hidden: true },
  { key: "اطار", icon: "🖼️", color: "#2980b9", hidden: true },
  { key: "🚀 رسم - بدأ", icon: "🚀", color: "#7b2ff7", hidden: true },
  { key: "✅ رسم - مكتمل", icon: "✅", color: "#00a651", hidden: true },
  { key: "عند الرسام", icon: "🖌️", color: "#c2185b" },
  { key: "تغليف", icon: "📦", color: "#d35400" },
  { key: "تم التوصيل", icon: "🚚", color: "#2e7d32" },
  { key: "تم التركيب", icon: "🛠️", color: "#1565c0" },
  { key: "   📩 تم التوصيل_فيدباك", icon: "📩", color: "#6a1b9a" },
];

// ✅ عدد الطلبات لكل مرحلة - محسوب على الطلبات قبل تطبيق فلتر البوكسات نفسه
// (لهيك الأعداد ما تتصفر لما توختار بوكس معين)
const workflowStageCounts = useMemo(() => {
  const counts = {};
  workflowStages.forEach(({ key }) => {
    counts[key] = prePipelineOrders.filter((order) =>
      matchStatusKey(order, key)
    ).length;
  });
  return counts;
}, [prePipelineOrders]);





const uniqueGovernorates =
  backendFilterOptions?.governorates || [
    "الكل",
    ...new Set(orders.map((o) => o.governorate).filter(Boolean)),
  ];
const uniqueSources =
  backendFilterOptions?.sources || [
    "الكل",
    ...new Set(orders.map((o) => o.source).filter(Boolean)),
  ];
const uniqueOrderTypes = [
  "الكل",
  "project_hotel",
  "project_restaurant",
  "project_cafe",
  "project_salon",
  "project_clinic",
  "project_beauty_center",
"project_hospital",
  "engineer_designer",
  "engineering_company",
  "other_company",
  "apartment",
  "house",
    // ✅ الجدد
  "influencer",
  "furniture_company",
];

// ✅ يبني قائمة الطلبات بعد تطبيق كل الفلاتر الحالية ما عدا الفلتر المحدد (skipField)
// تُستخدم فقط لحساب عدد الطلبات المطابق لكل خيار داخل قوائم الفلاتر (لا تُستخدم للفلترة الفعلية)
const buildBaseOrders = (skipField) => {
  let result = [...orders];
  result = result.filter((order) => !order.excludedFromStats);

  if (saleAccountFilter !== "ماركتنك") {
    result = result.filter((order) => (order.saleAccount || "بيع") !== "ماركتنك");
  }

  if (skipField !== "employee") {
    result = result.filter((order) => matchFilter(order.employee, selectedEmployee));
  }

  if (skipField !== "status" && selectedStatus.length > 0) {
    result = result.filter((order) =>
      selectedStatus.some((selected) => matchStatusKey(order, selected))
    );
  }

  if (skipField !== "governorate") {
    result = result.filter((order) => matchFilter(order.governorate, selectedGovernorate));
  }

  if (skipField !== "source") {
    result = result.filter((order) => orderMatchesSourceFilter(order, selectedSource));
  }

  if (saleAccountFilter !== "الكل") {
    result = result.filter((order) => (order.saleAccount || "بيع") === saleAccountFilter);
  }

  if (yearFilter !== "الكل" && debouncedSearchTerm.trim() === "") {
    result = result.filter((order) => {
      const d = toDateSafe(order.createdAt);
      if (!d) return false;
      return d.getFullYear() === yearFilter;
    });
  }

  if (yearFilter !== "الكل" && yearStatOwner === yearFilter) {
    result = result.filter((order) => matchYearStatFilter(order, yearStatFilter));
  }

  if (debouncedSearchTerm.trim() !== "") {
    result = result.filter((order) => matchSearch(order, debouncedSearchTerm));
  }

  if (skipField !== "payment" && paymentFilter.length > 0 && !paymentFilter.includes("الكل")) {
    result = result.filter((order) =>
      paymentFilter.some((filter) => {
        if (filter === "مدفوع") return isPaymentVisible(order);
        if (filter === "غير مدفوع") return !isPaymentVisible(order);
        return false;
      })
    );
  }

  if (skipField !== "paymentMethod") {
    result = result.filter((order) => matchFilter(order.payment?.method, paymentMethodFilter));
  }

  if (fromDate && toDate) {
    const from = new Date(fromDate);
    const to = new Date(toDate);
    result = result.filter((order) => {
      const createdAt = toDateSafe(order.createdAt);
      return createdAt >= from && createdAt <= to;
    });
  }

  if (selectedMonth) {
    result = result.filter((order) => {
      const date = toDateSafe(order.createdAt);
      if (!date) return false;
      const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
      return key === selectedMonth;
    });
  }

  if (activeStatFilter) {
    result = result.filter((order) => matchStatBoxFilter(order, activeStatFilter));
  }

  if (skipField !== "orderType" && selectedOrderType.length > 0 && !selectedOrderType.includes("الكل")) {
    result = result.filter((order) => orderMatchesTypes(order, selectedOrderType));
  }

  if (pipelineStatusFilter) {
    result = result.filter((order) => matchStatusKey(order, pipelineStatusFilter));
  }

  return result;
};

// ✅ عدد الطلبات المطابق لكل خيار داخل كل فلتر (يُعرض بجانب اسم الخيار في القائمة)
const employeeCounts = useMemo(() => {
  const base = buildBaseOrders("employee");
  const counts = {};
  uniqueEmployees.forEach((name) => {
    counts[name] = name === "الكل" ? base.length : base.filter((o) => o.employee === name).length;
  });
  return counts;
}, [orders, selectedStatus, selectedGovernorate, selectedSource, selectedOrderType, paymentFilter, paymentMethodFilter, saleAccountFilter, yearFilter, yearStatFilter, yearStatOwner, fromDate, toDate, selectedMonth, activeStatFilter, debouncedSearchTerm, pipelineStatusFilter, uniqueEmployees]);

const governorateCounts = useMemo(() => {
  const base = buildBaseOrders("governorate");
  const counts = {};
  uniqueGovernorates.forEach((g) => {
    counts[g] = g === "الكل" ? base.length : base.filter((o) => o.governorate === g).length;
  });
  return counts;
}, [orders, selectedEmployee, selectedStatus, selectedSource, selectedOrderType, paymentFilter, paymentMethodFilter, saleAccountFilter, yearFilter, yearStatFilter, yearStatOwner, fromDate, toDate, selectedMonth, activeStatFilter, debouncedSearchTerm, pipelineStatusFilter, uniqueGovernorates]);

const sourceCounts = useMemo(() => {
  const base = buildBaseOrders("source");
  const counts = {};
  uniqueSources.forEach((s) => {
    counts[s] = s === "الكل" ? base.length : base.filter((o) => o.source === s).length;
  });
  // ✅ Facebook و Instagram و WhatsApp: عدّهم يُحسب من تفصيل مصدر السوشال ميديا داخل نفس القائمة
  counts["Facebook"] = base.filter(
    (o) => o.source === "سوشال ميديا" && o.socialMediaSource === "Facebook"
  ).length;
  counts["Instagram"] = base.filter(
    (o) => o.source === "سوشال ميديا" && o.socialMediaSource === "Instagram"
  ).length;
  counts["WhatsApp"] = base.filter(
    (o) => o.source === "سوشال ميديا" && o.socialMediaSource === "WhatsApp"
  ).length;
  return counts;
}, [orders, selectedEmployee, selectedStatus, selectedGovernorate, selectedOrderType, paymentFilter, paymentMethodFilter, saleAccountFilter, yearFilter, yearStatFilter, yearStatOwner, fromDate, toDate, selectedMonth, activeStatFilter, debouncedSearchTerm, pipelineStatusFilter, uniqueSources]);

const orderTypeCounts = useMemo(() => {
  const base = buildBaseOrders("orderType");
  const counts = {};
  uniqueOrderTypes.forEach((t) => {
    counts[t] = t === "الكل" ? base.length : base.filter((o) => orderMatchesTypes(o, [t])).length;
  });
  return counts;
}, [orders, selectedEmployee, selectedStatus, selectedGovernorate, selectedSource, paymentFilter, paymentMethodFilter, saleAccountFilter, yearFilter, yearStatFilter, yearStatOwner, fromDate, toDate, selectedMonth, activeStatFilter, debouncedSearchTerm, pipelineStatusFilter]);

const statusCounts = useMemo(() => {
  const base = buildBaseOrders("status");
  const counts = {};
  fixedStatuses.forEach((s) => {
    counts[s] = s === "الكل" ? base.length : base.filter((o) => matchStatusKey(o, s)).length;
  });
  return counts;
}, [orders, selectedEmployee, selectedGovernorate, selectedSource, selectedOrderType, paymentFilter, paymentMethodFilter, saleAccountFilter, yearFilter, yearStatFilter, yearStatOwner, fromDate, toDate, selectedMonth, activeStatFilter, debouncedSearchTerm, pipelineStatusFilter]);

const paymentCounts = useMemo(() => {
  const base = buildBaseOrders("payment");
  return {
    "الكل": base.length,
    "مدفوع": base.filter((o) => isPaymentVisible(o)).length,
    "غير مدفوع": base.filter((o) => !isPaymentVisible(o)).length,
  };
}, [orders, selectedEmployee, selectedStatus, selectedGovernorate, selectedSource, selectedOrderType, paymentMethodFilter, saleAccountFilter, yearFilter, yearStatFilter, yearStatOwner, fromDate, toDate, selectedMonth, activeStatFilter, debouncedSearchTerm, pipelineStatusFilter]);

const paymentMethodCounts = useMemo(() => {
  const base = buildBaseOrders("paymentMethod");
  const methods = ["الكل", "deposit", "deposit_cash", "full_online", "full_cash", "cash_on_delivery"];
  const counts = {};
  methods.forEach((m) => {
    counts[m] = m === "الكل" ? base.length : base.filter((o) => o.payment?.method === m).length;
  });
  return counts;
}, [orders, selectedEmployee, selectedStatus, selectedGovernorate, selectedSource, selectedOrderType, paymentFilter, saleAccountFilter, yearFilter, yearStatFilter, yearStatOwner, fromDate, toDate, selectedMonth, activeStatFilter, debouncedSearchTerm, pipelineStatusFilter]);



 // مجموع السعر للطلبات بعد الفلترة (حسب الفلاتر العامة مثل الموظف، المحافظة، التاريخ)
const totalPrice = useMemo(() => {
  return filteredOrders.reduce(
    (sum, order) => sum + (parseFloat(order.price) || 0),
    0
  );
}, [filteredOrders]);

// 💰 تحليل الدفع حسب الفلاتر الحالية
const paymentAnalysis = useMemo(() => {
  const onlinePayments = filteredOrders.filter(
    (o) =>
      o.payment?.method === "full_online" ||
      o.payment?.method === "deposit"
  );

  const getPaidAmount = (o) =>
    o.payment?.method === "deposit"
      ? Number(o.payment?.depositAmount || 0)
      : Number(o.price || 0);

  const totalOnlineAmount = onlinePayments.reduce(
    (sum, o) => sum + getPaidAmount(o),
    0
  );

  const qiTotal = onlinePayments
    .filter((o) => o.payment?.provider === "Qi Card")
    .reduce((sum, o) => sum + getPaidAmount(o), 0);

  const zainTotal = onlinePayments
    .filter((o) => o.payment?.provider === "Zain Cash")
    .reduce((sum, o) => sum + getPaidAmount(o), 0);

  const fibTotal = onlinePayments
    .filter((o) => o.payment?.provider === "FIB")
    .reduce((sum, o) => sum + getPaidAmount(o), 0);

  return {
    onlinePayments,
    totalOnlineAmount,
    qiTotal,
    zainTotal,
    fibTotal,
  };
}, [filteredOrders]);

const { onlinePayments, totalOnlineAmount, qiTotal, zainTotal, fibTotal } =
  paymentAnalysis;

  const showPaymentAnalysis =
  paymentMethodFilter.includes("deposit") ||
  paymentMethodFilter.includes("full_online");




// ✅ بعد (يحسب من الطلبات المفلترة)
const positiveCount = filteredOrders.filter((o) => o.feedback?.type === "ايجابي").length;
const negativeCount = filteredOrders.filter((o) => o.feedback?.type === "سلبي").length;
// ✅ عدد الطلبات الفريدة التي تحتوي مشاكل (فيدباك سلبي)




// البيانات الثابتة للطلبات القديمة حسب كل شهر
const staticOldMonths = {
   // 🔹 Jan 2025
  "2025-01": {
    salesCount: 2,
    salesTotal: 695000,
    marketingCount: 0,
    marketingTotal: 0,
  },

  // 🔹 Feb 2025
  "2025-02": {
    salesCount: 10,
    salesTotal: 2060000,
    marketingCount: 0,
    marketingTotal: 0,
  },

  // 🔹 Mar 2025
  "2025-03": {
    salesCount: 12,
    salesTotal: 3275000,
    marketingCount: 0,
    marketingTotal: 0,
  },

  // 🔹 Apr 2025
  "2025-04": {
    salesCount: 12,
    salesTotal: 2050000,
    marketingCount: 0,
    marketingTotal: 0,
  },
  "2025-05": {
    salesCount: 2,
    salesTotal: 450000,
    marketingCount: 11,
    marketingTotal: 2894000,
  },
  "2025-06": {
    salesCount: 4,
    salesTotal: 4425000,
    marketingCount: 23,
    marketingTotal: 7307000,
  },
  "2025-07": {
    salesCount: 5,
    salesTotal: 5464000,
    marketingCount: 13,
    marketingTotal: 3563000,
  },
};

const frontendMonthlyBreakdownWithStatic = useMemo(() => {
  const monthlyBreakdown = {};

  orders.forEach((order) => {
    const date = toDateSafe(order.createdAt);
    if (!date) return;

    const key = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}`;

    if (!monthlyBreakdown[key]) {
      monthlyBreakdown[key] = {
        count: 0,
        total: 0,
        paid: 0,
        remaining: 0,

        marketingCount: 0,
        marketingTotal: 0,

        totalBoardsCount: 0,
        drawingOrdersCount: 0,
        drawingBoardsCount: 0,
        assemblyOrdersCount: 0,

        negativeCount: 0,
        negativeTotal: 0,
      };
    }

    monthlyBreakdown[key].totalBoardsCount += Number(order.boardsCount || 0);

    const price = Number(order.price) || 0;

    if (order.feedback?.type === "سلبي") {
      monthlyBreakdown[key].negativeCount += 1;
      monthlyBreakdown[key].negativeTotal += price;
    }

    monthlyBreakdown[key].count += 1;

    if ((order.saleAccount || "بيع") === "ماركتنك") {
      monthlyBreakdown[key].marketingCount += 1;
      monthlyBreakdown[key].marketingTotal += price;
    } else {
      monthlyBreakdown[key].total += price;
    }

    if ((order.saleAccount || "بيع") !== "ماركتنك") {
      if (isPaymentVisible(order)) {
        monthlyBreakdown[key].paid += price;
      } else {
        monthlyBreakdown[key].remaining += price;
      }
    }

    if (order.withDrawing === true) {
      monthlyBreakdown[key].drawingOrdersCount += 1;
      monthlyBreakdown[key].drawingBoardsCount += Number(
        order.drawingBoardsCount || 0
      );
    }

    if (order.withAssembly === true) {
      monthlyBreakdown[key].assemblyOrdersCount += 1;
    }
  });

  const result = {
    ...monthlyBreakdown,
  };

  for (const [month, data] of Object.entries(staticOldMonths)) {
    if (!result[month]) {
      result[month] = {
        count: data.salesCount + data.marketingCount,
        total: data.salesTotal + data.marketingTotal,
        paid: 0,
        remaining: 0,
        marketingCount: data.marketingCount || 0,
        marketingTotal: data.marketingTotal || 0,
        totalBoardsCount: 0,
        drawingOrdersCount: 0,
        drawingBoardsCount: 0,
        assemblyOrdersCount: 0,
        negativeCount: 0,
        negativeTotal: 0,
        isStatic: true,
        staticDetails: data,
      };
    }
  }

  return result;
}, [orders, staticOldMonths]);

const monthlyBreakdownWithStatic =
  backendMonthlyBreakdownWithStatic &&
  Object.keys(backendMonthlyBreakdownWithStatic).length > 0
    ? backendMonthlyBreakdownWithStatic
    : frontendMonthlyBreakdownWithStatic;
// 📌 اجمالي الطلبات (من الفلاتر فقط - Firebase)
const totalOrdersCount = filteredOrders.length;
const totalOrdersAmount = filteredOrders.reduce(
  (sum, order) => sum + (parseFloat(order.price) || 0),
  0
);

// ✅ اجمالي المكتمل (من الفلاتر فقط - Firebase)
const deliveredOrders = filteredOrders.filter((order) =>
  ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status)
);

const totalDelivered = deliveredOrders.length;
const deliveredAmount = deliveredOrders.reduce(
  (sum, o) => sum + (parseFloat(o.price) || 0),
  0
);

// ✅ اجمالي قيد العمل (من الفلاتر فقط - Firebase)
const inProgressOrders = filteredOrders.filter(
  (order) =>
    !["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status)
);
const negativeIssuesDetails =
  backendHeavyStats?.negativeIssuesDetails ||
  buildNegativeIssuesDetails(filteredOrders);

const totalInProgress = inProgressOrders.length;
const priceInProgress = inProgressOrders.reduce(
  (sum, o) => sum + (parseFloat(o.price) || 0),
  0
);

// 📌 اجمالي الطلبات القديمة الثابتة (5،6،7) — كلها مكتملة
const staticTotals =
  backendYearStats?.staticTotals ||
  Object.values(staticOldMonths).reduce(
    (acc, m) => {
      acc.count += (m.salesCount || 0) + (m.marketingCount || 0);
      acc.total += (m.salesTotal || 0) + (m.marketingTotal || 0);
      return acc;
    },
    { count: 0, total: 0 }
  );
// ✅ دمج الأشهر الثابتة داخل سنة 2025 فقط


// ✅ قرار: إذا المستخدم مختار "الكل" بدون أي فلاتر → نجمع مع الثابتة
const isAllFilter =
  selectedEmployee === "الكل" &&
  selectedGovernorate === "الكل" &&
  selectedSource === "الكل" &&
  !fromDate &&
  !toDate &&
  !selectedMonth;

// 📌 المجموع النهائي
const grandTotalCount = isAllFilter ? totalOrdersCount + staticTotals.count : totalOrdersCount;
const grandTotalAmount = isAllFilter ? totalOrdersAmount + staticTotals.total : totalOrdersAmount;

// 📌 المجموع النهائي للمكتمل
const grandDeliveredCount = isAllFilter ? totalDelivered + staticTotals.count : totalDelivered;
const grandDeliveredAmount = isAllFilter ? deliveredAmount + staticTotals.total : deliveredAmount;

// دمج الطلبات القديمة مع البيانات الحقيقية لكل شهر


const getOrderYear = (order) => {
  const d = toDateSafe(order.createdAt);
  if (!d) return null;
  return d.getFullYear();
};


const buildYearStats = (year, sourceOrders) => {
  const yearOrders = sourceOrders.filter(
    (o) =>
          !o.excludedFromStats &&   // ✅ أضف هذا
      getOrderYear(o) === year &&
      (o.saleAccount || "بيع") !== "ماركتنك"
  );
  const totalCount = yearOrders.length;
  const totalAmount = yearOrders.reduce((s, o) => s + (Number(o.price) || 0), 0);

  const doneOrders = yearOrders.filter((o) =>
    ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(o.status)
  );
  const doneCount = doneOrders.length;
  const doneAmount = doneOrders.reduce((s, o) => s + (Number(o.price) || 0), 0);

  const inProgressOrders = yearOrders.filter(
    (o) =>
      !["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(o.status)
  );
  const inProgressCount = inProgressOrders.length;
  const inProgressAmount = inProgressOrders.reduce(
    (s, o) => s + (Number(o.price) || 0),
    0
  );

  const positive = yearOrders.filter((o) => o.feedback?.type === "ايجابي").length;
  const negative = yearOrders.filter((o) => o.feedback?.type === "سلبي").length;

  // 🧩 عدد اللوحات
  const boardsCount = yearOrders.reduce(
    (acc, o) => acc + Number(o.boardsCount || 0),
    0
  );

  // 🎨 عدد الطلبات اللي بيها رسم
  const drawingOrdersCount = yearOrders.filter((o) => o.withDrawing === true).length;

  // 🖌️ عدد لوحات الرسم
  const drawingBoardsCount = yearOrders.reduce(
    (acc, o) => acc + Number(o.drawingBoardsCount || 0),
    0
  );

  return {
    totalCount,
    totalAmount,
    doneCount,
    doneAmount,
    inProgressCount,
    inProgressAmount,
    positive,
    negative,
    boardsCount,
    drawingOrdersCount,
    drawingBoardsCount,
  };
};

const stats2025 = backendYearStats?.stats2025 || buildYearStats(2025, orders);
const stats2026 = backendYearStats?.stats2026 || buildYearStats(2026, orders);
const shouldAddStatic = yearFilter === "الكل" || yearFilter === 2025;

// ✅ دمج الأشهر الثابتة داخل سنة 2025 فقط
const stats2025WithStatic =
  backendYearStats?.stats2025WithStatic || {
    ...stats2025,

    totalCount: stats2025.totalCount + staticTotals.count,
    totalAmount: stats2025.totalAmount + staticTotals.total,

    doneCount: stats2025.doneCount + staticTotals.count,
    doneAmount: stats2025.doneAmount + staticTotals.total,
  };

// ✅ مجموع 2025 + 2026 (بدون تغيير أي بروسيس)
const statsAllYears = useMemo(() => {
  const doneOrders = filteredOrders.filter((o) =>
    ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(
      o.status
    )
  );

  const inProgressOrders = filteredOrders.filter(
    (o) =>
      ![
        "تم التوصيل",
        "تركيب",
        "تم التركيب",
        "تم التوصيل (بعد الفيدباك)",
      ].includes(o.status)
  );

  return {
    totalCount:
      filteredOrders.length + (shouldAddStatic ? staticTotals.count : 0),

    totalAmount:
      filteredOrders.reduce((s, o) => s + (Number(o.price) || 0), 0) +
      (shouldAddStatic ? staticTotals.total : 0),

    doneCount: doneOrders.length + (shouldAddStatic ? staticTotals.count : 0),

    doneAmount:
      doneOrders.reduce((s, o) => s + (Number(o.price) || 0), 0) +
      (shouldAddStatic ? staticTotals.total : 0),

    inProgressCount: inProgressOrders.length,

    inProgressAmount: inProgressOrders.reduce(
      (s, o) => s + (Number(o.price) || 0),
      0
    ),

    positive: filteredOrders.filter((o) => o.feedback?.type === "ايجابي")
      .length,

    negative: filteredOrders.filter((o) => o.feedback?.type === "سلبي").length,

    boardsCount: filteredOrders.reduce(
      (s, o) => s + Number(o.boardsCount || 0),
      0
    ),

    drawingOrdersCount: filteredOrders.filter((o) => o.withDrawing === true)
      .length,

    drawingBoardsCount: filteredOrders.reduce(
      (s, o) => s + Number(o.drawingBoardsCount || 0),
      0
    ),

    installOrdersCount: filteredOrders.filter((o) => o.withAssembly === true)
      .length,
  };
}, [filteredOrders, shouldAddStatic, staticTotals]);

// ✅ دالة لإعادة تسمية الحالات في واجهة المدير
const renameStatus = (status, order) => {
  if (!status) return "";

  return getDisplayStatus(status, order).replace(
    "feedbackRequired",
    " 📩 تم التوصيل_فيدباك  "
  );
};

const orderTypeLabels = {
  project_hotel: "مشروع - فندق",
  project_restaurant: "مشروع - مطعم",
  project_cafe: "مشروع - كافيه",
  project_salon: "مشروع - صالون",
  project_clinic: "مشروع - عيادة",
project_beauty_center: "مشروع - مركز تجميل",
project_hospital: "مشروع - مستشفى",

  engineer_designer: "مهندس أو مصمم",
  engineering_company: "شركة هندسية أو شركة تصميم داخلي",

  other_company: "شركات أخرى",

  apartment: "شقة",
  house: "بيت",
    // ✅ الجدد
  influencer: "انفلونسر / بلوكر / مشهور",
  furniture_company: "شركة اثاث"
};

const getSaleAccount = (o) => o.saleAccount || "بيع"; // للطلبات القديمة

const saleAccountAnalysis = useMemo(() => {
  const salesOnlyOrders = orders.filter((o) => getSaleAccount(o) !== "ماركتنك");
  const narcyOrders = orders.filter((o) => getSaleAccount(o) === "حساب نرسي");
  const marwanOrders = orders.filter(
    (o) => getSaleAccount(o) === "حساب استاذ مروان"
  );
  const sudaSumerOrders = orders.filter(
    (o) => getSaleAccount(o) === "مطبعة صدى سومر - أبو زينب (زبون)"
  );
  const marketingOrders = orders.filter(
    (o) => getSaleAccount(o) === "ماركتنك"
  );

  const sumPrice = (arr) =>
    arr.reduce((acc, o) => acc + (Number(o.price) || 0), 0);

  return {
    salesOnlyOrders,
    narcyOrders,
    marwanOrders,
    sudaSumerOrders,
    marketingOrders,
    totalNarcy: sumPrice(narcyOrders),
    totalMarwan: sumPrice(marwanOrders),
    totalSudaSumer: sumPrice(sudaSumerOrders),
    totalMarketing: sumPrice(marketingOrders),
  };
}, [orders]);

const {
  salesOnlyOrders,
  narcyOrders,
  marwanOrders,
  sudaSumerOrders,
  marketingOrders,
  totalNarcy,
  totalMarwan,
  totalSudaSumer,
  totalMarketing,
} = saleAccountAnalysis;

const sumPrice = (arr) =>
  arr.reduce((acc, o) => acc + (Number(o.price) || 0), 0);

// ✅ حساب نرسي/مروان/صدى سومر/ماركتنك (بعدد+مبلغ) وعدد طلبات التركيب لسنة معيّنة لوحدها
// (مستقل عن backendYearStats حتى يشتغل دائمًا بغض النظر عن البيانات الجاهزة من الباك اند)
const buildYearExtraStats = (year) => {
  const yearOrders = orders.filter((o) => getOrderYear(o) === year);
  const narcy = yearOrders.filter((o) => getSaleAccount(o) === "حساب نرسي");
  const marwan = yearOrders.filter(
    (o) => getSaleAccount(o) === "حساب استاذ مروان"
  );
  const sudaSumer = yearOrders.filter(
    (o) => getSaleAccount(o) === "مطبعة صدى سومر - أبو زينب (زبون)"
  );
  const marketing = yearOrders.filter(
    (o) => getSaleAccount(o) === "ماركتنك"
  );

  return {
    narcyCount: narcy.length,
    totalNarcy: sumPrice(narcy),
    marwanCount: marwan.length,
    totalMarwan: sumPrice(marwan),
    sudaSumerCount: sudaSumer.length,
    totalSudaSumer: sumPrice(sudaSumer),
    marketingCount: marketing.length,
    totalMarketing: sumPrice(marketing),
    installOrdersCount: yearOrders.filter((o) => o.withAssembly === true)
      .length,
  };
};

const yearExtra2026 = buildYearExtraStats(2026);
const yearExtra2025 = buildYearExtraStats(2025);

// ✅ مبيعات Firebase بدون ماركتنك
const totalSalesOnlyFirebase = sumPrice(
  orders.filter((o) => (o.saleAccount || "بيع") !== "ماركتنك")
);

// ✅ مبيعات الأشهر الثابتة بدون ماركتنك (Sales فقط)
const staticSalesTotal = Object.values(staticOldMonths).reduce(
  (acc, m) => acc + (m.salesTotal || 0),
  0
);

// ✅ إذا كل الفلاتر "الكل" → اجمع Firebase + الثابتة
const totalSalesOnly = isAllFilter
  ? totalSalesOnlyFirebase + staticSalesTotal
  : totalSalesOnlyFirebase;
// ✅ ترتيب الأشهر: 2026 فوق (تنازلي) + 2025 تحت (تصاعدي)
const sortedMonthEntries = Object.entries(monthlyBreakdownWithStatic)
  .sort((a, b) => new Date(b[0] + "-01") - new Date(a[0] + "-01"));
const handleOrderAccordionChange = (orderId) => (event, isExpanded) => {
  setExpandedOrderId(isExpanded ? orderId : null);
};
// ✅ إذا تم اختيار بوكس وسيلة دفع (Qi/Zain/FIB) تظهر بس الطلبات المرتبطة فيه
const providerFilteredOrders = selectedProviderBox
  ? displayOrders.filter((o) => o.payment?.provider === selectedProviderBox)
  : displayOrders;
// 🔄 بوكس "الطلبات الكلية" (الصف العام) - يرجّع كل الفلاتر لوضع فتح الصفحة
const resetAllFilters = () => {
  setSelectedEmployee([]);
  setSelectedStatus([]);
  setSelectedGovernorate([]);
  setSelectedSource([]);
  setSelectedOrderType([]);
  setPaymentFilter([]);
  setPaymentMethodFilter([]);
  setFromDate("");
  setToDate("");
  setSearchTerm("");
  setSelectedMonth(null);
  setActiveStatFilter(null);
  setSaleAccountFilter("الكل");
  setYearFilter(2026);
  setYearStatFilter("all");
  setYearStatOwner(null);
  setPipelineStatusFilter(null);
  setSelectedProviderBox(null);
};

// ✅ بوكسات الصف العام (إحصائيات): دوسة تفعّل، ودوسة ثانية تلغي
const toggleStatBox = (key) =>
  setActiveStatFilter(activeStatFilter === key ? null : key);

// ✅ بوكسات صفوف السنين (إحصائيات): تفلتر داخل نفس السنة، ودوسة ثانية ترجع "الكلية" للسنة
const isYearStatActive = (year, key) =>
  yearFilter === year && yearStatOwner === year && yearStatFilter === key;
const toggleYearStatBox = (year, key) => {
  setSelectedMonth(null);
  setYearFilter(year);
  setYearStatOwner(year);
  setYearStatFilter(isYearStatActive(year, key) ? "all" : key);
};

// ✅ بوكسات حساب البيع بصفوف السنين: نفس فلتر حساب البيع + فلتر السنة
const isYearAccountActive = (year, account) =>
  yearFilter === year && saleAccountFilter === account;
const toggleYearAccountBox = (year, account) => {
  const active = isYearAccountActive(year, account);
  setSelectedMonth(null);
  setYearFilter(year);
  setYearStatOwner(year);
  setYearStatFilter("all");
  setSaleAccountFilter(active ? "الكل" : account);
};

const visibleOrders = providerFilteredOrders.slice(0, visibleOrdersCount);
const hasMoreOrders = visibleOrdersCount < providerFilteredOrders.length;
  return (
    <Container sx={{ mt: 4 }} dir="rtl">
      <Typography
        variant="h4"
        align="right"
        gutterBottom
        fontWeight={600}
        sx={{ mb: 3, fontSize: { xs: "1.6rem", sm: "2.125rem" } }}
      >
        لوحة المدير
      </Typography>
{isAdminViewer && (
<Box
  sx={{
    display: "grid",
    // 📱 عمودين على الموبايل، ونفس التوزيع القديم على الشاشات الأكبر
    gridTemplateColumns: {
      xs: "repeat(2, minmax(0, 1fr))",
      sm: "repeat(auto-fit, minmax(200px,1fr))",
    },
    gap: { xs: 1.25, sm: 2 },
    mb: 4,
  }}
>

  {/* 🔒 زر "إضافة طلب" مخفي مؤقتاً - الطلب يُنشأ الآن تلقائياً عبر اعتماد
      الفاتورة اللي توجّه لـ/add برمجياً (InvoiceViewPage.jsx's handleApprove).
      المسار /add نفسه ما زال شغال، فقط الزر مخفي - رجّعه بإزالة التعليق إذا
      احتجنا الإدخال اليدوي مرة ثانية. */}
  {false && (
    <Button
      variant="contained"
      color="primary"
      onClick={() => navigate("/add")}
      sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}
    >
      ➕ إضافة طلب
    </Button>
  )}

  <Button
    variant="contained"
    color="primary"
    onClick={() =>
      window.open("https://admin-artika.netlify.app/login", "_blank")
    }
      sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}

  >
    ادارة الطلبات
  </Button>

  <Button
    variant="contained"
    color="secondary"
    onClick={() => navigate("/tasks")}
         sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}

  >
    ادارة المهام
  </Button>

 <Button
    variant="contained"
    color="success"
    onClick={exportToExcel}
       sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}

  >
    📥 سحب الطلبات إلى Excel
  </Button>

  <Button
    variant="outlined"
    onClick={() => navigate("/todo")}
      sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}

  >
    📋 TO-DO LIST
  </Button>

<Button variant="contained"
onClick={() => navigate("/project-cost")}
      sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}

>
  🏗️ حساب كلفة المشروع
</Button>

  {/* 📄 عروض الأسعار (التسعيرات + عروض فواتير المشاريع) */}
  <Button
    variant="contained"
    sx={{ ...dashboardBoxStyle, backgroundColor: "#131414" }}
    onClick={() => navigate("/proposals")}
  >
    📄 عروض الأسعار
  </Button>

  <Button
    variant="contained"
      sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}

    onClick={() => navigate("/invoice-stats")}
  >
    📊 إحصائيات الفواتير
  </Button>

  <Button
    variant="contained"
    color="info"
    onClick={() =>
      navigate("/charts", {
        state: {
          orders,
          monthlyBreakdownWithStatic,
        },
      })
    }
       sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}

  >
    📊 التقارير الرسومية
  </Button>

<Button
  variant="contained"
  color="warning"
  onClick={() => setDelayDialogOpen(true)}
       sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}

>
  ⏱️ تقرير التأخير
</Button>

<Button
  variant="contained"
  color="primary"
  onClick={() => navigate("/leave-admin")}
        sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}

>
   إدارة الموظفين
</Button>

    <Grid item xs={6} sm={4} md={2}>
      <Paper
        sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}
        onClick={() => navigate("/site-visit")}
      >
        📍 زيارة موقع
      </Paper>
    </Grid>

 <Grid item xs={6} sm={4} md={2}>
    <Paper
      sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}
      onClick={() => navigate("/leads")}
    >
      📌 الزبائن المحتملين
    </Paper>
  </Grid>

 <Grid item xs={6} sm={4} md={2}>
      <Paper
       onClick={() => navigate("/all-stage-videos")}
  sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}
>🎬 فيديوات كل المراحل
      </Paper>
    </Grid>

 <Grid item xs={6} sm={4} md={2}>
    <Paper
      sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}
      onClick={() => navigate("/baneen-inventory")}
    >
      📦 المخزن
    </Paper>
  </Grid>

    <Grid item xs={6} sm={4} md={2}>
      <Paper
      onClick={() => navigate("/secondary-partners")}
 sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}
  >
    🏢 مخزن الشركاء الثانويين
      </Paper>
    </Grid>

    <Grid item xs={6} sm={4} md={2}>
      <Paper
      onClick={() => navigate("/material-requests-admin")}
 sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}
  >
    📦 طلبات المواد
      </Paper>
    </Grid>

<Button color="inherit" onClick={() => navigate("/artika-ai")}>
  🤖 Artika AI
</Button>
  <Button color="inherit" onClick={() => navigate("/ai-admin")}>
    AI Admin
  </Button>

  <Button
    variant="contained"
    onClick={() => navigate("/model-arena")}
    sx={{
      ...dashboardBoxStyle,
      background: "linear-gradient(90deg, #19c37d, #7c6ff2, #d97757)",
      color: "#06070d",
      fontWeight: 800,
    }}
  >
    🌪️ دوّامة العباقرة
  </Button>

  <Button
    variant="contained"
    onClick={() => navigate("/user-permissions")}
    sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}
  >
    🔐 صلاحية المستخدمين
  </Button>

</Box>
)}

{showPaymentAnalysis && (
  <Box
    sx={{
      mt: 2,
      p: 2,
      border: "1px solid #ddd",
      borderRadius: 2,
      background: "#fafafa",
    }}
  >
    <Typography fontWeight="bold" mb={1}>
      💰 تحليل الدفعات (حسب الفلاتر)
    </Typography>

    {/* المجموع */}
    <Typography fontSize={16} fontWeight={600} mb={2}>
      إجمالي الدفعات: {totalOnlineAmount.toLocaleString()} د.ع
    </Typography>

    {/* التفصيل - بوكسات قابلة للضغط لعرض الطلبات المرتبطة بكل وسيلة دفع */}
    <Box display="flex" gap={2} flexWrap="wrap">
      {[
        { provider: "Qi Card", icon: "💳", label: "Qi Card", total: qiTotal, color: "#7b2ff7" },
        { provider: "Zain Cash", icon: "📱", label: "Zain Cash", total: zainTotal, color: "#00a651" },
        { provider: "FIB", icon: "🏦", label: "FIB", total: fibTotal, color: "#0057b8" },
      ].map(({ provider, icon, label, total, color }) => {
        const isActive = selectedProviderBox === provider;
        return (
          <Paper
            key={provider}
            onClick={() =>
              setSelectedProviderBox((prev) => (prev === provider ? null : provider))
            }
            elevation={isActive ? 4 : 1}
            sx={{
              p: 2,
              minWidth: 150,
              textAlign: "center",
              cursor: "pointer",
              borderRadius: 2.5,
              border: isActive ? `2px solid ${color}` : "1px solid #e0e0e0",
              background: isActive ? `${color}14` : "#fff",
              transition: "all 0.15s ease",
              "&:hover": {
                borderColor: color,
                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
              },
            }}
          >
            <Typography fontSize={22} lineHeight={1.2}>
              {icon}
            </Typography>
            <Typography fontSize={13} color="text.secondary" fontWeight={600} mt={0.5}>
              {label}
            </Typography>
            <Typography fontWeight="bold" fontSize={16} sx={{ color }}>
              {total.toLocaleString()} د.ع
            </Typography>
          </Paper>
        );
      })}
    </Box>
    {selectedProviderBox && (
      <Typography fontSize={13} color="text.secondary" mt={1.5}>
        🔎 يتم عرض الطلبات الخاصة بـ «{selectedProviderBox}» فقط بالأسفل — اضغط على البوكس مرة أخرى لإلغاء الفلترة
      </Typography>
    )}
  </Box>
)}
     <Box
  display="grid"
  sx={{
    // 📱 عمودين بالموبايل، 3 بالتابلت، و6 (نفس السابق) بالشاشات الكبيرة
    gridTemplateColumns: {
      xs: "repeat(2, minmax(0, 1fr))",
      sm: "repeat(3, minmax(0, 1fr))",
      md: "repeat(6, 1fr)",
    },
    gap: 0.75,
    mb: 3,
    "& .MuiButtonBase-root": {
      fontSize: "0.72rem",
      padding: "4px 8px",
      minWidth: "auto",
      width: "100%",
      lineHeight: 1.3,
      overflowWrap: "anywhere",
    },
  }}
  dir="rtl"
>
  <Button
  variant={!activeStatFilter && saleAccountFilter === "الكل" ? "contained" : "outlined"}
  onClick={resetAllFilters}
>
  الطلبات الكلية | {statsAllYears.totalCount} | {statsAllYears.totalAmount.toLocaleString()} د.ع
</Button>

 <Button
    variant={saleAccountFilter === "حساب استاذ مروان" ? "contained" : "outlined"}
    color="info"
onClick={() =>
  setSaleAccountFilter(saleAccountFilter === "حساب استاذ مروان" ? "الكل" : "حساب استاذ مروان")
}
  >
    🧾 حساب استاذ مروان: {totalMarwan.toLocaleString()} د.ع
  </Button>

  <Button
    variant={saleAccountFilter === "حساب نرسي" ? "contained" : "outlined"}
    color="secondary"
onClick={() =>
  setSaleAccountFilter(saleAccountFilter === "حساب نرسي" ? "الكل" : "حساب نرسي")
}
  >
    🧾 حساب نرسي: {totalNarcy.toLocaleString()} د.ع
  </Button>

  <Button
    variant={saleAccountFilter === "ماركتنك" ? "contained" : "outlined"}
    color="warning"
onClick={() =>
  setSaleAccountFilter(saleAccountFilter === "ماركتنك" ? "الكل" : "ماركتنك")
}
  >
    📣 ماركتنك | {marketingOrders.length} | {totalMarketing.toLocaleString()} د.ع
  </Button>

   <Button
  variant={activeStatFilter === "positive" ? "contained" : "outlined"}
  color="success"
  onClick={() =>
    setActiveStatFilter(activeStatFilter === "positive" ? null : "positive")
  }
>
👍 إيجابي: {statsAllYears.positive}
</Button>

<Button
  variant={activeStatFilter === "negative" ? "contained" : "outlined"}
  color="error"
  onClick={() =>
    setActiveStatFilter(activeStatFilter === "negative" ? null : "negative")
  }
>
👎 سلبي: {statsAllYears.negative}
</Button>

<Button
  variant={activeStatFilter === "boards" ? "contained" : "outlined"}
  sx={activeStatFilter === "boards"
    ? { bgcolor: "#6a1b9a", "&:hover": { bgcolor: "#4a148c" } }
    : { color: "#6a1b9a", borderColor: "#6a1b9a" }}
  onClick={() => toggleStatBox("boards")}
>
  🧩 عدد اللوحات الكلية: {statsAllYears.boardsCount}
</Button>

<Button
  variant={activeStatFilter === "drawingOrders" ? "contained" : "outlined"}
  color="secondary"
  onClick={() => toggleStatBox("drawingOrders")}
>
  🎨  طلبات الرسم الكلية : {statsAllYears.drawingOrdersCount}
</Button>

<Button
  variant={activeStatFilter === "drawingBoards" ? "contained" : "outlined"}
  color="secondary"
  onClick={() => toggleStatBox("drawingBoards")}
>
  🖌️   لوحات الرسم الكلية: {statsAllYears.drawingBoardsCount}
</Button>

<Button
  variant={activeStatFilter === "install" ? "contained" : "outlined"}
  color="secondary"
  onClick={() => toggleStatBox("install")}
>
  🔧 عدد طلبات التركيب: {statsAllYears.installOrdersCount}
</Button>

  <Button
  variant={activeStatFilter === "done" ? "contained" : "outlined"}
  color="success"
  onClick={() =>
    setActiveStatFilter(activeStatFilter === "done" ? null : "done")
  }
>
المكتملة | {statsAllYears.doneCount} | {statsAllYears.doneAmount.toLocaleString()} د.ع
</Button>

  <Button
    variant={activeStatFilter === "inProgress" ? "contained" : "outlined"}
    color="warning"
    onClick={() =>
      setActiveStatFilter(activeStatFilter === "inProgress" ? null : "inProgress")
    }
  >
قيد العمل | {statsAllYears.inProgressCount} | {statsAllYears.inProgressAmount.toLocaleString()} د.ع
  </Button>

</Box>
<Box display="flex" mb={1} dir="rtl">
  <Button
    variant={saleAccountFilter === "مطبعة صدى سومر - أبو زينب (زبون)" ? "contained" : "outlined"}
    sx={{ color: "#00695c", borderColor: "#00695c" }}
    onClick={() =>
      setSaleAccountFilter(
        saleAccountFilter === "مطبعة صدى سومر - أبو زينب (زبون)" ? "الكل" : "مطبعة صدى سومر - أبو زينب (زبون)"
      )
    }
  >
    🧾 مطبعة صدى سومر - أبو زينب (زبون): {totalSudaSumer.toLocaleString()} د.ع
  </Button>
</Box>
{/* ✅ سطر سنة 2026 */}
<Box display="flex" mb={1} dir="rtl">
<Button
  variant={yearFilter === 2026 ? "contained" : "outlined"}
  onClick={() => {
    setSelectedMonth(null);
      setYearStatOwner(2026);
    setYearStatFilter("all"); // ✅ هناااا
    setYearFilter(yearFilter === 2026 ? "الكل" : 2026);
  }}
>
  📅 2026
</Button>
</Box>
<Box
  display="grid"
  sx={{
    // 📱 عمودين بالموبايل، 3 بالتابلت، و6 (نفس السابق) بالشاشات الكبيرة
    gridTemplateColumns: {
      xs: "repeat(2, minmax(0, 1fr))",
      sm: "repeat(3, minmax(0, 1fr))",
      md: "repeat(6, 1fr)",
    },
    gap: 0.75,
    mb: 3,
    "& .MuiButtonBase-root": {
      fontSize: "0.72rem",
      padding: "4px 8px",
      minWidth: "auto",
      width: "100%",
      lineHeight: 1.3,
      overflowWrap: "anywhere",
    },
  }}
  dir="rtl"
>
<Button
  variant={yearFilter === 2026 && yearStatOwner === 2026 && yearStatFilter === "all" && saleAccountFilter === "الكل" ? "contained" : "outlined"}
  onClick={() => {
    const active = yearFilter === 2026 && yearStatOwner === 2026 && yearStatFilter === "all" && saleAccountFilter === "الكل";
    setSelectedMonth(null);
    setYearStatOwner(2026);
    setYearStatFilter("all");
    setSaleAccountFilter("الكل");
    setYearFilter(active ? "الكل" : 2026);
  }}
>
  الطلبات الكلية | {stats2026.totalCount} | {stats2026.totalAmount.toLocaleString()} د.ع
</Button>
<Button
  variant={isYearAccountActive(2026, "حساب استاذ مروان") ? "contained" : "outlined"}
  color="info"
  onClick={() => toggleYearAccountBox(2026, "حساب استاذ مروان")}
>
    🧾 حساب استاذ مروان: {yearExtra2026.totalMarwan.toLocaleString()} د.ع
  </Button>
  <Button
    variant={isYearAccountActive(2026, "حساب نرسي") ? "contained" : "outlined"}
    color="secondary"
    onClick={() => toggleYearAccountBox(2026, "حساب نرسي")}
  >
    🧾 حساب نرسي: {yearExtra2026.totalNarcy.toLocaleString()} د.ع
  </Button>

  <Button
    variant={isYearAccountActive(2026, "ماركتنك") ? "contained" : "outlined"}
    color="warning"
    onClick={() => toggleYearAccountBox(2026, "ماركتنك")}
  >
    📣 ماركتنك | {yearExtra2026.marketingCount} | {yearExtra2026.totalMarketing.toLocaleString()} د.ع
  </Button>

  <Button
    variant={isYearStatActive(2026, "positive") ? "contained" : "outlined"}
    color="success"
    onClick={() => toggleYearStatBox(2026, "positive")}
  >
    👍 إيجابي: {stats2026.positive}
  </Button>

  <Button
    variant={isYearStatActive(2026, "negative") ? "contained" : "outlined"}
    color="error"
    onClick={() => toggleYearStatBox(2026, "negative")}
  >
    👎 سلبي: {stats2026.negative}
  </Button>

<Button
  variant={isYearStatActive(2026, "boards") ? "contained" : "outlined"}
  sx={isYearStatActive(2026, "boards")
    ? { bgcolor: "#6a1b9a", "&:hover": { bgcolor: "#4a148c" } }
    : { color: "#6a1b9a", borderColor: "#6a1b9a" }}
  onClick={() => toggleYearStatBox(2026, "boards")}
>
  🧩 عدد اللوحات: {stats2026.boardsCount}
</Button>

<Button
  variant={isYearStatActive(2026, "drawingOrders") ? "contained" : "outlined"}
  color="secondary"
  onClick={() => toggleYearStatBox(2026, "drawingOrders")}
>
  🎨 طلبات الرسم: {stats2026.drawingOrdersCount}
</Button>

<Button
  variant={isYearStatActive(2026, "drawingBoards") ? "contained" : "outlined"}
  color="secondary"
  onClick={() => toggleYearStatBox(2026, "drawingBoards")}
>
  🖌️ لوحات الرسم: {stats2026.drawingBoardsCount}
</Button>

<Button
  variant={isYearStatActive(2026, "install") ? "contained" : "outlined"}
  color="secondary"
  onClick={() => toggleYearStatBox(2026, "install")}
>
  🔧 عدد طلبات التركيب: {yearExtra2026.installOrdersCount}
</Button>

<Button
  variant={isYearStatActive(2026, "done") ? "contained" : "outlined"}
  color="success"
  onClick={() => toggleYearStatBox(2026, "done")}
>
  المكتملة | {stats2026.doneCount} | {stats2026.doneAmount.toLocaleString()} د.ع
</Button>

<Button
  variant={isYearStatActive(2026, "inProgress") ? "contained" : "outlined"}
  color="warning"
  onClick={() => toggleYearStatBox(2026, "inProgress")}
>
  قيد العمل | {stats2026.inProgressCount} | {stats2026.inProgressAmount.toLocaleString()} د.ع
</Button>

</Box>
<Box display="flex" mb={1} dir="rtl">
  <Button
    variant={isYearAccountActive(2026, "مطبعة صدى سومر - أبو زينب (زبون)") ? "contained" : "outlined"}
    sx={isYearAccountActive(2026, "مطبعة صدى سومر - أبو زينب (زبون)")
      ? { bgcolor: "#00695c", "&:hover": { bgcolor: "#004d40" } }
      : { color: "#00695c", borderColor: "#00695c" }}
    onClick={() => toggleYearAccountBox(2026, "مطبعة صدى سومر - أبو زينب (زبون)")}
  >
    🧾 مطبعة صدى سومر - أبو زينب (زبون) | {yearExtra2026.sudaSumerCount} | {yearExtra2026.totalSudaSumer.toLocaleString()} د.ع
  </Button>
</Box>

{/* ✅ سطر سنة 2025 */}
<Box display="flex" mb={1} dir="rtl">
<Button
  variant={yearFilter === 2025 ? "contained" : "outlined"}
  onClick={() => {
    setSelectedMonth(null);
    setYearStatOwner(2025);
    setYearStatFilter("all"); // ✅ هناااا
    setYearFilter(yearFilter === 2025 ? "الكل" : 2025);
  }}
>
  📅 2025
</Button>
</Box>
<Box
  display="grid"
  sx={{
    // 📱 عمودين بالموبايل، 3 بالتابلت، و6 (نفس السابق) بالشاشات الكبيرة
    gridTemplateColumns: {
      xs: "repeat(2, minmax(0, 1fr))",
      sm: "repeat(3, minmax(0, 1fr))",
      md: "repeat(6, 1fr)",
    },
    gap: 0.75,
    mb: 2,
    "& .MuiButtonBase-root": {
      fontSize: "0.72rem",
      padding: "4px 8px",
      minWidth: "auto",
      width: "100%",
      lineHeight: 1.3,
      overflowWrap: "anywhere",
    },
  }}
  dir="rtl"
>
<Button
  variant={yearFilter === 2025 && yearStatOwner === 2025 && yearStatFilter === "all" && saleAccountFilter === "الكل" ? "contained" : "outlined"}
  onClick={() => {
    const active = yearFilter === 2025 && yearStatOwner === 2025 && yearStatFilter === "all" && saleAccountFilter === "الكل";
    setSelectedMonth(null);
    setYearStatOwner(2025);
    setYearStatFilter("all");
    setSaleAccountFilter("الكل");
    setYearFilter(active ? "الكل" : 2025);
  }}
>
  الطلبات الكلية | {stats2025WithStatic.totalCount} | {stats2025WithStatic.totalAmount.toLocaleString()} د.ع
</Button>
<Button
  variant={isYearAccountActive(2025, "حساب استاذ مروان") ? "contained" : "outlined"}
  color="info"
  onClick={() => toggleYearAccountBox(2025, "حساب استاذ مروان")}
>
    🧾 حساب استاذ مروان: {yearExtra2025.totalMarwan.toLocaleString()} د.ع
  </Button>
  <Button
    variant={isYearAccountActive(2025, "حساب نرسي") ? "contained" : "outlined"}
    color="secondary"
    onClick={() => toggleYearAccountBox(2025, "حساب نرسي")}
  >
    🧾 حساب نرسي: {yearExtra2025.totalNarcy.toLocaleString()} د.ع
  </Button>

  <Button
    variant={isYearAccountActive(2025, "ماركتنك") ? "contained" : "outlined"}
    color="warning"
    onClick={() => toggleYearAccountBox(2025, "ماركتنك")}
  >
    📣 ماركتنك | {yearExtra2025.marketingCount} | {yearExtra2025.totalMarketing.toLocaleString()} د.ع
  </Button>

  <Button
    variant={isYearStatActive(2025, "positive") ? "contained" : "outlined"}
    color="success"
    onClick={() => toggleYearStatBox(2025, "positive")}
  >
    👍 إيجابي: {stats2025.positive}
  </Button>

  <Button
    variant={isYearStatActive(2025, "negative") ? "contained" : "outlined"}
    color="error"
    onClick={() => toggleYearStatBox(2025, "negative")}
  >
    👎 سلبي: {stats2025.negative}
  </Button>

<Button
  variant={isYearStatActive(2025, "boards") ? "contained" : "outlined"}
  sx={isYearStatActive(2025, "boards")
    ? { bgcolor: "#6a1b9a", "&:hover": { bgcolor: "#4a148c" } }
    : { color: "#6a1b9a", borderColor: "#6a1b9a" }}
  onClick={() => toggleYearStatBox(2025, "boards")}
>
  🧩 عدد اللوحات: {stats2025WithStatic.boardsCount}
</Button>

<Button
  variant={isYearStatActive(2025, "drawingOrders") ? "contained" : "outlined"}
  color="secondary"
  onClick={() => toggleYearStatBox(2025, "drawingOrders")}
>
  🎨 طلبات الرسم: {stats2025WithStatic.drawingOrdersCount}
</Button>

<Button
  variant={isYearStatActive(2025, "drawingBoards") ? "contained" : "outlined"}
  color="secondary"
  onClick={() => toggleYearStatBox(2025, "drawingBoards")}
>
  🖌️ لوحات الرسم: {stats2025WithStatic.drawingBoardsCount}
</Button>

<Button
  variant={isYearStatActive(2025, "install") ? "contained" : "outlined"}
  color="secondary"
  onClick={() => toggleYearStatBox(2025, "install")}
>
  🔧 عدد طلبات التركيب: {yearExtra2025.installOrdersCount}
</Button>

<Button
  variant={isYearStatActive(2025, "done") ? "contained" : "outlined"}
  color="success"
  onClick={() => toggleYearStatBox(2025, "done")}
>
  المكتملة | {stats2025WithStatic.doneCount} | {stats2025WithStatic.doneAmount.toLocaleString()} د.ع
</Button>

<Button
  variant={isYearStatActive(2025, "inProgress") ? "contained" : "outlined"}
  color="warning"
  onClick={() => toggleYearStatBox(2025, "inProgress")}
>
  قيد العمل | {stats2025WithStatic.inProgressCount} | {stats2025WithStatic.inProgressAmount.toLocaleString()} د.ع
</Button>

</Box>
<Box display="flex" mb={1} dir="rtl">
  <Button
    variant={isYearAccountActive(2025, "مطبعة صدى سومر - أبو زينب (زبون)") ? "contained" : "outlined"}
    sx={isYearAccountActive(2025, "مطبعة صدى سومر - أبو زينب (زبون)")
      ? { bgcolor: "#00695c", "&:hover": { bgcolor: "#004d40" } }
      : { color: "#00695c", borderColor: "#00695c" }}
    onClick={() => toggleYearAccountBox(2025, "مطبعة صدى سومر - أبو زينب (زبون)")}
  >
    🧾 مطبعة صدى سومر - أبو زينب (زبون) | {yearExtra2025.sudaSumerCount} | {yearExtra2025.totalSudaSumer.toLocaleString()} د.ع
  </Button>
</Box>




<Accordion sx={{ mb: 2 }}>
  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
    <Typography fontWeight="bold">⏱️ تحليل التأخير حسب الموظف</Typography>
  </AccordionSummary>

  <AccordionDetails>
    {performance.length === 0 ? (
      <Typography color="textSecondary">
        لا توجد بيانات كافية لحساب التأخير (تأكد أن الطلبات تحتوي history + timestamps)
      </Typography>
    ) : (
      <Box display="flex" flexDirection="column" gap={1}>
        {performance.map((p) => (
          <Paper key={p.owner} sx={{ p: 1 }}>
            <Typography fontWeight="bold">
              👤 {p.owner}
            </Typography>

            <Typography>
              🧾 عدد الطلبات اللي مرّت عليه: {p.ordersCount}
            </Typography>

           <Typography>
  ⏱️ مجموع الوقت: {formatDurationDaysOnly(p.totalMinutes)}
</Typography>

<Typography sx={{ color: "primary.main", fontWeight: "bold" }}>
  📌 معدل الوقت لكل طلب: {formatDurationDaysOnly(p.avgMinutesPerOrder)}
</Typography>

          </Paper>
        ))}
      </Box>
    )}
  </AccordionDetails>
</Accordion>
<Accordion sx={{ width: "100%", mt: 1 }}>
  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
    <Typography fontWeight="bold">الطلبات المرفوضة</Typography>

   
  </AccordionSummary>

  <AccordionDetails>

    <Typography fontWeight="bold" color="error.main">
      1️⃣ ملغية بسبب تأخير داخلي ({internalRejected.length})
    </Typography>

    {internalRejected.map(order => (
      <Paper key={order.id} sx={{ p: 1, mb: 1 }}>
        <Typography>📦 {order.customerName}</Typography>
        <Typography>👤 الموظف: {order.employee}</Typography>
        <Typography>📌 السبب: {order.rejectionReason}</Typography>
      </Paper>
    ))}

    <Typography fontWeight="bold" color="warning.main" mt={2}>
      2️⃣ وصلت متأخرة ورفضها الزبون ({lateRejected.length})
    </Typography>

    {lateRejected.map(order => (
      <Paper key={order.id} sx={{ p: 1, mb: 1 }}>
        <Typography>📦 {order.customerName}</Typography>
        <Typography>💰 {Number(order.price).toLocaleString()} د.ع</Typography>
      </Paper>
    ))}

    <Typography fontWeight="bold" color="error" mt={2}>
      3️⃣ متضررة ({damagedRejected.length})
    </Typography>

    {damagedRejected.map(order => (
      <Paper key={order.id} sx={{ p: 1, mb: 1 }}>
        <Typography>📦 {order.customerName}</Typography>
        <Typography>💰 {Number(order.price).toLocaleString()} د.ع</Typography>
      </Paper>
    ))}

  </AccordionDetails>
</Accordion>


     <Box
  display="grid"
  gridTemplateColumns={{
    xs: "repeat(2, minmax(0, 1fr))",
    sm: "repeat(3, minmax(0, 1fr))",
    md: "repeat(6, 1fr)",
  }}
  gap={{ xs: 1, md: 2 }}
  mb={4}
  dir="rtl"
>

{sortedMonthEntries
  .filter(([month]) => {
    if (yearFilter === "الكل") return true;
    return month.startsWith(String(yearFilter));
  })

  .map(([month, data]) => {
  const isActive = selectedMonth === month;

  // تخصيص عرض شهر 2025-07 فقط
  const displayCount = month === "2025-07" ? 18 : data.count;
  const displayTotal = month === "2025-07" ? 9027000 : data.total;

  return (
    <Paper
      key={month}
onClick={() => {
  const year = Number(month.split("-")[0]);
  setYearFilter(year); // ✅ يخلي السنة تلقائياً حسب الشهر
    setActiveStatFilter("all");
  setSelectedMonth(isActive ? null : month);
}}
      sx={{
        p: 2,
        minWidth: 160,
        backgroundColor: isActive ? "#e3f2fd" : "#f5f5f5",
        textAlign: "center",
        border: "1px solid #ccc",
        borderRadius: 2,
        cursor: "pointer",
        transition: "0.2s",
      }}
      elevation={isActive ? 4 : 1}
    >
      <Typography fontWeight={600}>{month}</Typography>
  <Typography fontSize={14}>
  💰 {(data.total || 0).toLocaleString()} د.ع
</Typography>
{data.marketingTotal > 0 && (
  <Typography fontSize={14} color="warning.main" fontWeight={600}>
    📣 ماركتنك: {data.marketingTotal.toLocaleString()} د.ع
    {data.marketingCount > 0 && ` (${data.marketingCount} طلب)`}
  </Typography>
)}

      <Typography fontSize={14}>📦 {displayCount} طلب</Typography>
      <Typography fontSize={14} color="#6a1b9a" fontWeight={600}>
  🧩 {data.totalBoardsCount || 0} لوحة
</Typography>
   
{data.drawingOrdersCount > 0 && (
  <>
    <Typography fontSize={14} color="secondary">
      🎨 {data.drawingOrdersCount} طلبات رسم
    </Typography>

    <Typography fontSize={14} color="secondary">
      🖌️ {data.drawingBoardsCount} لوحات رسم
    </Typography>
  </>
)}
{/* 🛠️ طلبات تحتوي تركيب */}
<Typography fontSize={14} color="#1565c0" fontWeight={600}>
 🛠️ {data.assemblyOrdersCount || 0} :   تركيب 
</Typography>

<Typography fontSize={13} color="textSecondary">
📈 معدل الطلبات: {data.dailyAverage || getDailyAverage(month, data.count)} طلب/يوم
</Typography>


<Typography fontSize={13} color="green">
  ✅ تم الدفع: {(data.paid || 0).toLocaleString()} د.ع
</Typography>

<Typography fontSize={13} color="error">
  ⏳ المتبقي: {(data.remaining || 0).toLocaleString()} د.ع
</Typography>
{data.negativeCount > 0 && (
  <Typography
    fontSize={13}
    color="error.main"
    fontWeight={700}
    sx={{ mt: 0.5 }}
  >
    👎 الطلبات المرفوضة | {data.negativeCount} |{" "}
    {(data.negativeTotal || 0).toLocaleString()} د.ع
  </Typography>
)}

    </Paper>
  );
})}

        
      </Box>
{selectedMonth &&
  staticOldMonths[selectedMonth] && (
    <Box
      sx={{
        mt: 2,
        p: 2,
        border: "1px dashed #1976d2",
        borderRadius: 2,
        backgroundColor: "#f0f8ff",
      }}
    >
      <Typography variant="h6" fontWeight="bold" color="primary">
        تفاصيل شهر {selectedMonth}
      </Typography>

      <Typography>
        🟢 عدد طلبات Sales: {staticOldMonths[selectedMonth].salesCount}
      </Typography>
      <Typography>
        💰 مجموع Sales:{" "}
        {staticOldMonths[selectedMonth].salesTotal.toLocaleString()} د.ع
      </Typography>

      <Typography>
        🔵 عدد طلبات Marketing: {staticOldMonths[selectedMonth].marketingCount}
      </Typography>
      <Typography>
        💰 مجموع Marketing:{" "}
        {staticOldMonths[selectedMonth].marketingTotal.toLocaleString()} د.ع
      </Typography>
    </Box>
  )}

<Grid
  container
  spacing={2}
  sx={{
    mb: 3,
    alignItems: "center",
    background: "#fafafa",
    p: 2,
    borderRadius: 3,
  }}
>   
 <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="🔍 بحث باسم الزبون أو رقم الهاتف (يشمل الماركتنك)"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="من"
            type="date"
            fullWidth
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="إلى"
            type="date"
            fullWidth
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
       <Grid item xs={12} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink sx={{ right: 0, left: "auto" }}>الموظف</InputLabel>
        <Select
  multiple
  value={selectedEmployee}
  onChange={(e) => setSelectedEmployee(e.target.value)}
  renderValue={(selected) => selected.join(" , ")}
>
  {uniqueEmployees.map((name) => (
    <MenuItem key={name} value={name}>
      <Checkbox checked={selectedEmployee.indexOf(name) > -1 || selectedEmployee.includes("الكل")} />
      <ListItemText primary={`${name} - ${employeeCounts[name] ?? 0}`} />
    </MenuItem>
  ))}
</Select>
          </FormControl>
        </Grid>
      <Grid item xs={12} md={3}>
<FormControl fullWidth>
<InputLabel shrink sx={{ right: 0, left: "auto" }}>المحافظة</InputLabel>

<Select
multiple
value={selectedGovernorate}
onChange={(e) => setSelectedGovernorate(e.target.value)}
renderValue={(selected) => selected.join(" ، ")}
>

{uniqueGovernorates.map((g) => (
<MenuItem key={g} value={g}>
<Checkbox checked={selectedGovernorate.indexOf(g) > -1 || selectedGovernorate.includes("الكل")}/>
<ListItemText primary={`${g} - ${governorateCounts[g] ?? 0}`}/>
</MenuItem>
))}

</Select>
</FormControl>
</Grid>
       
      <Grid item xs={12} md={3}>
<FormControl fullWidth>
<InputLabel shrink sx={{ right: 0, left: "auto" }}>مصدر الطلب</InputLabel>

<Select
multiple
value={selectedSource}
onChange={(e) => setSelectedSource(e.target.value)}
renderValue={(selected) => selected.join(" ، ")}
>

{uniqueSources.flatMap((s) => {
  const items = [
    <MenuItem key={s} value={s}>
      <Checkbox checked={selectedSource.indexOf(s) > -1 || selectedSource.includes("الكل")}/>
      <ListItemText primary={`${s} - ${sourceCounts[s] ?? 0}`}/>
      {s === "سوشال ميديا" && (
        <ExpandMoreIcon
          fontSize="small"
          onClick={(e) => {
            e.stopPropagation();
            setSocialMediaMenuOpen((v) => !v);
          }}
          sx={{
            ml: 1,
            color: "text.secondary",
            transform: socialMediaMenuOpen ? "rotate(180deg)" : "none",
            transition: "transform 0.2s",
          }}
        />
      )}
    </MenuItem>,
  ];

  // ✅ Facebook و Instagram و WhatsApp: قائمة فرعية تطلع تحت "سوشال ميديا" بنفس فلتر مصدر الطلب لما نضغط عليها
  if (s === "سوشال ميديا" && socialMediaMenuOpen) {
    items.push(
      <MenuItem key="Facebook" value="Facebook" sx={{ pl: 4 }}>
        <Checkbox checked={selectedSource.indexOf("Facebook") > -1 || selectedSource.includes("الكل")}/>
        <ListItemText primary={`Facebook - ${sourceCounts["Facebook"] ?? 0}`}/>
      </MenuItem>,
      <MenuItem key="Instagram" value="Instagram" sx={{ pl: 4 }}>
        <Checkbox checked={selectedSource.indexOf("Instagram") > -1 || selectedSource.includes("الكل")}/>
        <ListItemText primary={`Instagram - ${sourceCounts["Instagram"] ?? 0}`}/>
      </MenuItem>,
      <MenuItem key="WhatsApp-social" value="WhatsApp" sx={{ pl: 4 }}>
        <Checkbox checked={selectedSource.indexOf("WhatsApp") > -1 || selectedSource.includes("الكل")}/>
        <ListItemText primary={`WhatsApp - ${sourceCounts["WhatsApp"] ?? 0}`}/>
      </MenuItem>
    );
  }

  return items;
})}

</Select>
</FormControl>
</Grid>

<Grid item xs={12} md={3}>
<FormControl fullWidth>
<InputLabel shrink sx={{ right: 0, left: "auto" }}>نوع الزبون</InputLabel>

<Select
multiple
value={selectedOrderType}
onChange={(e) => setSelectedOrderType(e.target.value)}
renderValue={(selected)=>
selected.map(t=>orderTypeLabels[t] || t).join(" ، ")
}
>

{uniqueOrderTypes.map((t) => (
<MenuItem key={t} value={t}>
<Checkbox checked={selectedOrderType.indexOf(t) > -1 || selectedOrderType.includes("الكل")}/>
<ListItemText primary={`${orderTypeLabels[t] || t} - ${orderTypeCounts[t] ?? 0}`}/>
</MenuItem>
))}

</Select>
</FormControl>
</Grid>
<Grid item xs={12} md={3}>
<FormControl fullWidth>
  <InputLabel shrink sx={{ right: 0, left: "auto" }}>الحالة</InputLabel>

<Select
multiple
value={selectedStatus}
onChange={(e) => setSelectedStatus(e.target.value)}
renderValue={(selected)=> selected.join(" ، ")}
>

{fixedStatuses.map((s) => (
<MenuItem key={s} value={s}>
<Checkbox checked={selectedStatus.indexOf(s) > -1 || selectedStatus.includes("الكل")}/>
<ListItemText primary={`${s} - ${statusCounts[s] ?? 0}`}/>
</MenuItem>
))}

</Select>
</FormControl>
</Grid>
<Grid item xs={12} md={3}>
<FormControl fullWidth>

<InputLabel shrink sx={{ right: 0, left: "auto" }}>
الدفع
</InputLabel>

<Select
multiple
value={paymentFilter}
onChange={(e)=>setPaymentFilter(e.target.value)}
renderValue={(selected)=>selected.join(" ، ")}
>

<MenuItem value="الكل">
<Checkbox checked={paymentFilter.indexOf("الكل") > -1}/>
<ListItemText primary={`الكل - ${paymentCounts["الكل"] ?? 0}`}/>
</MenuItem>

<MenuItem value="مدفوع">
<Checkbox checked={paymentFilter.indexOf("مدفوع") > -1 || paymentFilter.includes("الكل")}/>
<ListItemText primary={`مدفوع - ${paymentCounts["مدفوع"] ?? 0}`}/>
</MenuItem>

<MenuItem value="غير مدفوع">
<Checkbox checked={paymentFilter.indexOf("غير مدفوع") > -1 || paymentFilter.includes("الكل")}/>
<ListItemText primary={`غير مدفوع - ${paymentCounts["غير مدفوع"] ?? 0}`}/>
</MenuItem>

</Select>

</FormControl>
</Grid>
<Grid item xs={12} md={3}>
<FormControl fullWidth>
  <InputLabel shrink sx={{ right: 0, left: "auto" }}>
طريقة الدفع
</InputLabel>

<Select
multiple
value={paymentMethodFilter}
onChange={(e)=>setPaymentMethodFilter(e.target.value)}
renderValue={(selected)=>
selected.map(m=>paymentMethodLabel[m] || m).join(" ، ")
}
>

<MenuItem value="الكل">
<Checkbox checked={paymentMethodFilter.indexOf("الكل") > -1}/>
<ListItemText primary={`الكل - ${paymentMethodCounts["الكل"] ?? 0}`}/>
</MenuItem>

<MenuItem value="deposit">
<Checkbox checked={paymentMethodFilter.indexOf("deposit") > -1 || paymentMethodFilter.includes("الكل")}/>
<ListItemText primary={`دفعة أولية - ${paymentMethodCounts["deposit"] ?? 0}`}/>
</MenuItem>

<MenuItem value="deposit_cash">
<Checkbox checked={paymentMethodFilter.indexOf("deposit_cash") > -1 || paymentMethodFilter.includes("الكل")}/>
<ListItemText primary={`دفعة أولية كاش - ${paymentMethodCounts["deposit_cash"] ?? 0}`}/>
</MenuItem>


<MenuItem value="full_online">
<Checkbox checked={paymentMethodFilter.indexOf("full_online") > -1 || paymentMethodFilter.includes("الكل")}/>
<ListItemText primary={`دفع كامل أونلاين - ${paymentMethodCounts["full_online"] ?? 0}`}/>
</MenuItem>

<MenuItem value="full_cash">
<Checkbox checked={paymentMethodFilter.indexOf("full_cash") > -1 || paymentMethodFilter.includes("الكل")}/>
<ListItemText primary={`دفعة كاملة كاش - ${paymentMethodCounts["full_cash"] ?? 0}`}/>
</MenuItem>

<MenuItem value="cash_on_delivery">
<Checkbox checked={paymentMethodFilter.indexOf("cash_on_delivery") > -1 || paymentMethodFilter.includes("الكل")}/>
<ListItemText primary={`دفع عند الاستلام - ${paymentMethodCounts["cash_on_delivery"] ?? 0}`}/>
</MenuItem>

</Select>
</FormControl>
</Grid>
      </Grid>

<Box sx={{ mb: 3 }} dir="rtl">
  <Typography fontSize={13} color="text.secondary" fontWeight={600} mb={1}>
    🧭 مراحل العمل — اضغط على مرحلة لعرض طلباتها فقط
  </Typography>
  <Box display="flex" gap={1.5} flexWrap="wrap">
    {workflowStages.filter((stage) => !stage.hidden).map(({ key, icon, color }) => {
      const isActive = pipelineStatusFilter === key;
      return (
        <Paper
          key={key}
          onClick={() =>
            setPipelineStatusFilter((prev) => (prev === key ? null : key))
          }
          elevation={isActive ? 4 : 1}
          sx={{
            p: 1.5,
            minWidth: { xs: 0, sm: 120 },
            // 📱 3 بالصف بالموبايل وتملي العرض كامل
            flex: { xs: "1 1 calc(33.333% - 8px)", sm: "0 0 auto" },
            textAlign: "center",
            cursor: "pointer",
            borderRadius: 2.5,
            border: isActive ? `2px solid ${color}` : "1px solid #e0e0e0",
            background: isActive ? `${color}14` : "#fff",
            transition: "all 0.15s ease",
            "&:hover": {
              borderColor: color,
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
            },
          }}
        >
          <Typography fontSize={20} lineHeight={1.2}>
            {icon}
          </Typography>
          <Typography fontSize={12} color="text.secondary" fontWeight={600} mt={0.5}>
            {key.trim()}
          </Typography>
          <Typography fontWeight="bold" fontSize={16} sx={{ color }}>
            {workflowStageCounts[key] || 0}
          </Typography>
        </Paper>
      );
    })}
  </Box>
  {pipelineStatusFilter && (
    <Typography fontSize={13} color="text.secondary" mt={1.5}>
      🔎 يتم عرض طلبات مرحلة «{pipelineStatusFilter.trim()}» فقط — اضغط على المرحلة مرة أخرى لإلغاء الفلترة
    </Typography>
  )}
</Box>

     {visibleOrders.map((order) => (
 <Accordion
  key={order.id}
  expanded={expandedOrderId === order.id}
  onChange={handleOrderAccordionChange(order.id)}
  sx={{
    mb: 2,
    direction: "rtl",
        position: "relative", // ✅ مهم
    backgroundColor: ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status)
      ? "#c9ecd7" // ✅ أخضر زمردي راقي (مكتملة)
      : "#cfdff5", // أزرق سماوي راقي (قيد العمل) - بدون أي برتقالي
  }}
>


          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
           <Box
  sx={{
    display: "flex",
    // 📱 بالموبايل: النص فوق ودوائر المراحل تحته بدل ما ينضغط النص بعمود ضيق
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "stretch", sm: "center" },
    width: "100%",
    gap: { xs: "10px", sm: "14px" },
    paddingLeft: isPaymentVisible(order) ? { xs: "62px", sm: "100px" } : 0,
  }}
>
  <Typography
  component="div"
  sx={{
    fontWeight: "bold",
    fontSize: "0.9rem",
    textAlign: "right",
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  }}
>
  <span>
  {formatDateTimeSafe(order.createdAt)}
    | مصدر الطلب: {order.source || "غير محدد"}
    | حساب: {order.saleAccount || "بيع"}
    | طريقة الدفع: {paymentMethodLabel[order.payment?.method] || "—"}

| نوع الزبون : {orderTypeLabels[order.orderType] || order.orderType || "غير محدد"}
  </span>
 <span>
  الاسم | {order.customerName} | الحالة{" "}
{order.status === "عند برهان" && order.completedSteps?.length > 0
  ? renameStatus(`عند برهان - ${order.completedSteps[order.completedSteps.length - 1]}`)
  : renameStatus(order.status, order)}
<PrintChoiceBadge order={order} />
| المحافظة {order.governorate} | السعر{" "}
  {Number(order.price).toLocaleString()} د.ع
| 🧩 عدد اللوحات: {order.boardsCount || "—"}
{order.withDrawing && (
  <> | 🎨 عدد لوحات الرسم: {order.drawingBoardsCount || "—"}</>
)}

</span>
</Typography>

  <OrderStageBadges order={order} now={stageClockNow} />
</Box>
{isPaymentVisible(order) && (
  <Box
    sx={{
      position: "absolute",
      left: 0,
      top: 0,
      height: "100%",        // 🔥 نفس ارتفاع الكارد
      width: { xs: 54, sm: 90 }, // 🔥 مربع واضح (أصغر بالموبايل)
      backgroundColor: "#1f7a52",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      boxShadow: "inset 0 0 0 2px #145a3c",
      zIndex: 10,
    }}
  >
    <img
      src={paidIcon}        // ✅ نفس الصورة القديمة
      alt="مدفوع"
      style={{
        width: "67%",
        maxWidth: 60,
        aspectRatio: "1 / 1",
        objectFit: "contain",
      }}
    />
  </Box>
)}

          </AccordionSummary>
          <AccordionDetails>
{expandedOrderId === order.id && (
    <>

  {order.durationByYusuf !== undefined && (
  <Typography fontWeight="bold" color="green">
    ⏱️    الوقت المستغرق عند المصمم: {formatMinutesToDays(order.durationByYusuf)}
  </Typography>
)}

{(() => {
  const ownerDurations = calcOrderDurationsByOwner(order);
  return (
    <>
      {ownerDurations["المطبعة"] !== undefined && (
        <Typography fontWeight="bold" color="green">
          ⏱️ الوقت المستغرق عند المطبعة: {formatMinutesToDays(ownerDurations["المطبعة"])}
        </Typography>
      )}
      {ownerDurations["الورشة"] !== undefined && (
        <Typography fontWeight="bold" color="green">
          ⏱️ الوقت المستغرق عند الورشة: {formatMinutesToDays(ownerDurations["الورشة"])}
        </Typography>
      )}
      {order.withDrawing && ownerDurations["الرسام"] !== undefined && (
        <Typography fontWeight="bold" color="green">
          ⏱️ الوقت المستغرق عند الرسام: {formatMinutesToDays(ownerDurations["الرسام"])}
        </Typography>
      )}
    </>
  );
})()}

            <Typography gutterBottom>
              الرابط:{" "}
              <Link href={order.https} target="_blank">
                فتح
              </Link>
            </Typography>
            {order.source && (
  <Typography gutterBottom>
    مصدر الطلب: <strong>{order.source}</strong>
  </Typography>
)}
{/* أزرار صورة الفاتورة / مقارنة اللوحات / الموكاب / فيديو الرسم */}
<Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
  <Button
    variant="outlined"
    color="secondary"
    onClick={() => {
      if (!order.invoiceImageUrl) {
        alert("لا توجد صورة فاتورة مرفوعة لهذا الطلب");
        return;
      }
      setPreviewFile({ url: order.invoiceImageUrl, type: "image" });
    }}
  >
    🧾 صورة الفاتورة
  </Button>

  <Button
    variant="contained"
    color="secondary"
    onClick={() => navigate(`/compare-boards/${order.id}`)}
  >
    🖼️ مقارنة اللوحات
  </Button>

  <Button
    variant="outlined"
    color="secondary"
    onClick={() => {
      const images = order.mockupImages || [];
      if (!images.length) {
        alert("لا توجد صور موكاب مرفوعة لهذا الطلب");
        return;
      }
      if (images.length === 1) {
        setPreviewFile({ url: images[0], type: "image" });
      } else {
        setMockupDialogOrder(order);
      }
    }}
  >
    🖼️ الموكاب
  </Button>

  {order.withDrawing && ((order.videoLinks?.length > 0) || order.driveLink) && (
    <Button
      variant="outlined"
      color="secondary"
      onClick={() => {
        const videos = order.videoLinks || [];
        if (videos.length === 1) {
          setPreviewFile({ url: videos[0], type: "video" });
        } else if (videos.length > 1) {
          setVideoDialogOrder(order);
        } else if (order.driveLink) {
          window.open(order.driveLink, "_blank", "noopener");
        } else {
          alert("لا يوجد فيديو رسم مرفوع لهذا الطلب");
        }
      }}
    >
      🎥 فيديو الرسم
    </Button>
  )}

  {order.framingVideoLinks?.length > 0 && (
    <Button
      variant="outlined"
      color="secondary"
      onClick={() => {
        const videos = order.framingVideoLinks || [];
        if (videos.length === 1) {
          setPreviewFile({ url: videos[0], type: "video" });
        } else {
          setFramingVideoDialogOrder(order);
        }
      }}
    >
      🎥 فيديو التأطير
    </Button>
  )}

  {order.packagingVideoLinks?.length > 0 && (
    <Button
      variant="outlined"
      color="secondary"
      onClick={() => {
        const videos = order.packagingVideoLinks || [];
        if (videos.length === 1) {
          setPreviewFile({ url: videos[0], type: "video" });
        } else {
          setPackagingVideoDialogOrder(order);
        }
      }}
    >
      🎥 فيديو التغليف
    </Button>
  )}
</Box>
{/* 🖼️ عرض صور التركيب */}
{order.installationFiles && order.installationFiles.length > 0 && (
  <Box mt={2}>
    <Typography fontWeight="bold">📷 صور / فيديوهات التركيب:</Typography>

    <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
      {order.installationFiles.map((f, i) =>
        f.type === "image" ? (
          <Box
            key={i}
            sx={{
              cursor: "pointer",
              border: "1px solid #ccc",
              borderRadius: 2,
              overflow: "hidden",
              width: 100,
              height: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              "&:hover": { opacity: 0.8 },
            }}
            onClick={() => setPreviewFile(f)}
          >
            <img
              src={f.url}
              alt="installation"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ) : (
          <Button
            key={i}
            variant="outlined"
            size="small"
            onClick={() => window.open(f.url, "_blank")}
          >
            🎥 فيديو {i + 1}
          </Button>
        )
      )}
    </Box>
  </Box>
)}
{/* 🧾 فواتير الورشة (طباعة / إطارات) */}
{(order.printInvoice?.url || order.framesInvoice?.url) && (
  <Box mt={2}>
    <Typography variant="h6" color="primary">
      🧾 فواتير الطلب:
    </Typography>

    <Box display="flex" gap={2} flexWrap="wrap" mt={1}>
      {/* ✅ فاتورة الطباعة */}
      {order.printInvoice?.url && (
        <Box>
          <Typography fontWeight="bold">🖨️ فاتورة الطباعة:</Typography>

          <Box
            sx={{
              width: 140,
              height: 140,
              borderRadius: 2,
              overflow: "hidden",
              border: "1px solid #ccc",
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() =>
              setPreviewFile({ url: order.printInvoice.url, type: "image" })
            }
          >
            <img
              src={order.printInvoice.url}
              alt="print-invoice"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                // إذا كانت PDF أو ما تنعرض كصورة
                e.currentTarget.style.display = "none";
              }}
            />
            <Typography sx={{ fontSize: 12 }}>
              (إذا PDF افتح الرابط)
            </Typography>
          </Box>

          <Box mt={1}>
            <Link href={order.printInvoice.url} target="_blank" rel="noopener">
              🔗 فتح الفاتورة
            </Link>
          </Box>
        </Box>
      )}

      {/* ✅ فاتورة الإطارات */}
      {order.framesInvoice?.url && (
        <Box>
          <Typography fontWeight="bold">🖼️ فاتورة الإطارات:</Typography>

          <Box
            sx={{
              width: 140,
              height: 140,
              borderRadius: 2,
              overflow: "hidden",
              border: "1px solid #ccc",
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() =>
              setPreviewFile({ url: order.framesInvoice.url, type: "image" })
            }
          >
            <img
              src={order.framesInvoice.url}
              alt="frames-invoice"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
            <Typography sx={{ fontSize: 12 }}>
              (إذا PDF افتح الرابط)
            </Typography>
          </Box>

          <Box mt={1}>
            <Link href={order.framesInvoice.url} target="_blank" rel="noopener">
              🔗 فتح الفاتورة
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  </Box>
)}

            <Divider sx={{ my: 2 }} />
            {/* فيدباك الزبون (إذا موجود) */}
{order.feedback && (
  <Box mt={2}>
    <Typography variant="h6" color="primary">📩 فيدباك الزبون:</Typography>
    <Typography>النوع: <strong>{order.feedback.type}</strong></Typography>
    <Typography>الملاحظة: {order.feedback.note}</Typography>
  {/* 📷 صور الفيدباك */}
{order.feedback?.images && order.feedback.images.length > 0 ? (
  <Box mt={2}>
    <Typography fontWeight="bold">📷 صور الفيدباك:</Typography>

    <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
      {order.feedback.images.map((img, idx) => (
        <Box
          key={idx}
          sx={{
            width: 120,
            height: 120,
            borderRadius: 2,
            overflow: "hidden",
            border: "1px solid #ccc",
            cursor: "pointer",
            "&:hover": { opacity: 0.85 },
          }}
          onClick={() =>
            setPreviewFile({ url: img, type: "image" })
          }
        >
          <img
            src={img}
            alt={`feedback-${idx}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
      ))}
    </Box>
  </Box>
) : (
  // 🔙 دعم الصورة القديمة
  order.feedback?.image && (
    <Box mt={1}>
      <Typography fontWeight="bold">📷 صورة الفيدباك:</Typography>
      <img
        src={order.feedback.image}
        alt="صورة الفيدباك"
        style={{
          maxWidth: "100%",
          maxHeight: 300,
          borderRadius: 8,
          border: "1px solid #ccc",
        }}
      />
    </Box>
  )
)}

  </Box>
)}
{(() => {
  
  const durationMin = getOrderTotalDurationMinutes(order);

  return (
    <Typography fontWeight="bold" color="secondary">
      ⏳ مدة الطلب الكاملة:{" "}
{(() => {
  const start = toDateSafe(order.createdAt);
  if (!start) return null;

  const completedAt = getCompletionDate(order); // عندك موجودة فوق
  const now = new Date();

  const currentMinutes = Math.floor((now.getTime() - start.getTime()) / 60000);

  // ✅ إذا مكتمل
  if (completedAt) {
    const totalMinutes = Math.floor(
      (completedAt.getTime() - start.getTime()) / 60000
    );

    return (
      <Box mt={2}>
        <Typography fontWeight="bold" sx={{ color: "#6a1b9a" }}>
          🟣 مدة الطلب الكاملة: {formatDurationDaysOnly(totalMinutes)}
        </Typography>
      </Box>
    );
  }

  // ✅ إذا قيد العمل
  return (
    <Box mt={2}>
      <Typography fontWeight="bold" sx={{ color: "#ef6c00" }}>
        🟠 مدة الطلب الحالية: {formatDurationDaysOnly(currentMinutes)}
      </Typography>

      <Typography fontWeight="bold" sx={{ color: "#6a1b9a" }}>
        🟣 مدة الطلب الكاملة: قيد العمل
      </Typography>
    </Box>
  );
})()}

    </Typography>
  );
})()}



            <Typography gutterBottom>سجل الحالة:</Typography>
            <Box display="flex" flexDirection="column" gap={1}>
              {(() => {
                const historyList = [...(order.history || [])].sort(
                  (a, b) => getTime(b.timestamp) - getTime(a.timestamp)
                );
                const validTimes = historyList
                  .map((h) => getTime(h.timestamp))
                  .filter((t) => t > 0);
                // ✅ نعرض "بواسطة" فقط لأول مرحلة (إرسال الطلب) - أقدم عنصر
                // بالسجل زمنياً - وليس لبقية المراحل، بطلب المستخدم صراحة
                const earliestTime = validTimes.length ? Math.min(...validTimes) : null;
                return historyList.map((h, idx) => {
                  const ts = toDateSafe(h.timestamp);
                  const timestamp = ts
                    ? `${ts.getFullYear()}-${String(
                        ts.getMonth() + 1
                      ).padStart(2, "0")}-${String(ts.getDate()).padStart(
                        2,
                        "0"
                      )} ${String(ts.getHours()).padStart(2, "0")}:${String(
                        ts.getMinutes()
                      ).padStart(2, "0")}`
                    : "—";
                  const updatedBy = getDisplayName(h.updatedBy || h.by || "غير معروف");
                  const isFirstStage = earliestTime !== null && getTime(h.timestamp) === earliestTime;
                  return (
                    <Paper
                      key={idx}
                      sx={{ p: 1, backgroundColor: "#f9f9f9" }}
                      elevation={0}
                    >
                     <Typography variant="body2">
  <strong>الحالة:</strong> {renameStatus(h.status, order)}
</Typography>

                      {isFirstStage && (
                        <Typography variant="body2">
                          <strong>بواسطة:</strong> {updatedBy}
                        </Typography>
                      )}

                      <Typography variant="body2">
                        <strong>الوقت:</strong> {timestamp}
                      </Typography>

                    </Paper>

                  );
                });
              })()}
            </Box>
   
  </>
  )}
          </AccordionDetails>


        </Accordion>
      ))}
{hasMoreOrders && (
  <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
    <Button
      variant="contained"
      onClick={() => setVisibleOrdersCount((prev) => prev + 50)}
      sx={{ px: 5, py: 1.5, fontWeight: "bold" }}
    >
      تحميل المزيد من الطلبات
      {" "}
      ({Math.min(visibleOrdersCount, providerFilteredOrders.length)} / {providerFilteredOrders.length})
    </Button>
  </Box>
)}

{!hasMoreOrders && displayOrders.length > 50 && (
  <Box sx={{ textAlign: "center", my: 3 }}>
    <Typography color="text.secondary">
      تم عرض كل الطلبات ({displayOrders.length})
    </Typography>
  </Box>
)}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="success"
          variant="filled"
          onClose={() => setSnackbarOpen(false)}
        >
          ✅ تم حذف الطلب بنجاح!
        </Alert>
      </Snackbar>
 {/* 🔍 Dialog معاينة صورة / فيديو */}
<Dialog
  open={!!previewFile}
  onClose={() => setPreviewFile(null)}
  maxWidth="md"
  fullWidth
>
  <DialogContent
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 300,
    }}
  >
    {previewFile && previewFile.type === "image" && (
      <img
        src={previewFile.url}
        alt="preview"
        style={{
          maxWidth: "100%",
          maxHeight: "80vh",
          objectFit: "contain",
          borderRadius: 8,
        }}
      />
    )}

    {previewFile && previewFile.type === "video" && (
      <video
        src={previewFile.url}
        controls
        style={{
          maxWidth: "100%",
          maxHeight: "80vh",
          borderRadius: 8,
        }}
      />
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setPreviewFile(null)}>إغلاق</Button>
  </DialogActions>
</Dialog>

{/* 🖼️ Dialog عرض صور الموكاب (أكثر من صورة) */}
<Dialog
  open={!!mockupDialogOrder}
  onClose={() => setMockupDialogOrder(null)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>🖼️ صور الموكاب</DialogTitle>
  <DialogContent>
    <Box display="flex" gap={1} flexWrap="wrap">
      {(mockupDialogOrder?.mockupImages || []).map((url, index) => (
        <Box
          key={index}
          sx={{
            cursor: "pointer",
            border: "1px solid #ccc",
            borderRadius: 2,
            overflow: "hidden",
            width: 120,
            height: 120,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
            "&:hover": { opacity: 0.8 },
          }}
          onClick={() => {
            setPreviewFile({ url, type: "image" });
            setMockupDialogOrder(null);
          }}
        >
          <img
            src={url}
            alt={`mockup-${index}`}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Box>
      ))}
    </Box>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setMockupDialogOrder(null)}>إغلاق</Button>
  </DialogActions>
</Dialog>

{/* 🎥 Dialog عرض فيديوهات الرسم (أكثر من فيديو) */}
<Dialog
  open={!!videoDialogOrder}
  onClose={() => setVideoDialogOrder(null)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>🎥 فيديوهات الرسم</DialogTitle>
  <DialogContent>
    {(videoDialogOrder?.videoLinks || []).map((url, index) => (
      <Box key={index} sx={{ mb: 1 }}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => {
            setPreviewFile({ url, type: "video" });
            setVideoDialogOrder(null);
          }}
        >
          ▶️ مشاهدة الفيديو {index + 1}
        </Button>
      </Box>
    ))}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setVideoDialogOrder(null)}>إغلاق</Button>
  </DialogActions>
</Dialog>

{/* 🎥 Dialog عرض فيديوهات التأطير (أكثر من فيديو) */}
<Dialog
  open={!!framingVideoDialogOrder}
  onClose={() => setFramingVideoDialogOrder(null)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>🎥 فيديوهات التأطير</DialogTitle>
  <DialogContent>
    {(framingVideoDialogOrder?.framingVideoLinks || []).map((url, index) => (
      <Box key={index} sx={{ mb: 1 }}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => {
            setPreviewFile({ url, type: "video" });
            setFramingVideoDialogOrder(null);
          }}
        >
          ▶️ مشاهدة الفيديو {index + 1}
        </Button>
      </Box>
    ))}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setFramingVideoDialogOrder(null)}>إغلاق</Button>
  </DialogActions>
</Dialog>

{/* 🎥 Dialog عرض فيديوهات التغليف (أكثر من فيديو) */}
<Dialog
  open={!!packagingVideoDialogOrder}
  onClose={() => setPackagingVideoDialogOrder(null)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>🎥 فيديوهات التغليف</DialogTitle>
  <DialogContent>
    {(packagingVideoDialogOrder?.packagingVideoLinks || []).map((url, index) => (
      <Box key={index} sx={{ mb: 1 }}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => {
            setPreviewFile({ url, type: "video" });
            setPackagingVideoDialogOrder(null);
          }}
        >
          ▶️ مشاهدة الفيديو {index + 1}
        </Button>
      </Box>
    ))}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setPackagingVideoDialogOrder(null)}>إغلاق</Button>
  </DialogActions>
</Dialog>

<Dialog
  open={delayDialogOpen}
  onClose={() => setDelayDialogOpen(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>⏱️ تقرير التأخير</DialogTitle>

  <DialogContent dividers>


    {/* 🔹 تحليل عام */}
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
  
        <Typography fontWeight="bold">📊 تحليل عام لكل الطلبات</Typography>
      </AccordionSummary>
    <Box display="flex" gap={2} mb={2}>
  <TextField
    label="من تاريخ"
    type="date"
    value={fromDate}
    onChange={(e) => setFromDate(e.target.value)}
    InputLabelProps={{ shrink: true }}
  />

  <TextField
    label="إلى تاريخ"
    type="date"
    value={toDate}
    onChange={(e) => setToDate(e.target.value)}
    InputLabelProps={{ shrink: true }}
  />
</Box>
      <AccordionDetails>
        <Typography fontWeight="bold" color="primary" mt={2}>
📊 معدل إنجاز الطلب:
{formatDurationDaysOnly(avgOrderDuration)}
</Typography>
     <Typography fontWeight="bold" mt={2}>
🟢 أسرع 3 طلبات
</Typography>

      {fastestOrders.map(o => (
  <Typography key={o.id}>
    {o.name} — {formatDurationDaysOnly(o.minutes)}
  </Typography>
))}

<Typography fontWeight="bold" mt={2}>
🔴 أبطأ 3 طلبات
</Typography>

{slowestOrders.map(o => (
  <Typography key={o.id}>
    {o.name} — {formatDurationDaysOnly(o.minutes)}
  </Typography>
))}
      </AccordionDetails>
    </Accordion>

    {/* 🔹 تحليل حسب الموظف */}
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography fontWeight="bold">👤 تحليل التأخير حسب الموظف</Typography>
      </AccordionSummary>

      <AccordionDetails>
        {performance.length === 0 ? (
          <Typography color="text.secondary">
            لا توجد بيانات كافية
          </Typography>
        ) : (
          <Box display="flex" flexDirection="column" gap={1}>
            {performance.map((p) => (
              <Paper key={p.owner} sx={{ p: 1.5 }}>
                <Typography fontWeight="bold">👤 {p.owner}</Typography>
                <Typography>
                  🧾 عدد الطلبات: {p.ordersCount}
                </Typography>
                <Typography>
                  ⏱️ مجموع الوقت: {formatDurationDaysOnly(p.totalMinutes)}
                </Typography>
                <Typography color="primary" fontWeight="bold">
                  📌 المعدل لكل طلب:{" "}
                  {formatDurationDaysOnly(p.avgMinutesPerOrder)}
                </Typography>
              </Paper>
            ))}
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setDelayDialogOpen(false)}>إغلاق</Button>
  </DialogActions>
</Dialog>

    </Container>
  );
};

export default AdminDashboard;
